// Guardian AI Family Care application, booking, visit, receipt, and payroll evidence services.
//
// Guardian AI Inc. is the service provider. Parent rate offers inform matching,
// but Guardian AI controls assignment, caregiver reveal, payment, and payroll.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/familycare/family_care.proto (package guardianai.v1.familycare, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/familycare/family_care.proto.
 */
export const file_guardianai_v1_familycare_family_care: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.familycare.GetPublicSettingsRequest
 */
export type GetPublicSettingsRequest = Message<"guardianai.v1.familycare.GetPublicSettingsRequest"> & {
};

/**
 * @generated from message guardianai.v1.familycare.GetPublicSettingsRequest
 */
export type GetPublicSettingsRequestJson = {
};

/**
 * Describes the message guardianai.v1.familycare.GetPublicSettingsRequest.
 * Use `create(GetPublicSettingsRequestSchema)` to create a new message.
 */
export const GetPublicSettingsRequestSchema: GenMessage<GetPublicSettingsRequest, {jsonType: GetPublicSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 0);

/**
 * @generated from message guardianai.v1.familycare.GetPublicSettingsResponse
 */
export type GetPublicSettingsResponse = Message<"guardianai.v1.familycare.GetPublicSettingsResponse"> & {
  /**
   * @generated from field: bool service_enabled = 1;
   */
  serviceEnabled: boolean;

  /**
   * @generated from field: int32 minimum_booking_minutes = 2;
   */
  minimumBookingMinutes: number;

  /**
   * @generated from field: int32 booking_increment_minutes = 3;
   */
  bookingIncrementMinutes: number;

  /**
   * @generated from field: int64 client_hourly_rate_cents = 4;
   */
  clientHourlyRateCents: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.TaxMode tax_mode = 5;
   */
  taxMode: TaxMode;

  /**
   * @generated from field: int32 tax_rate_basis_points = 6;
   */
  taxRateBasisPoints: number;

  /**
   * @generated from field: repeated string service_areas = 7;
   */
  serviceAreas: string[];

  /**
   * @generated from field: string currency = 8;
   */
  currency: string;

  /**
   * @generated from field: string terms_version = 9;
   */
  termsVersion: string;

  /**
   * @generated from field: string privacy_notice_version = 10;
   */
  privacyNoticeVersion: string;

  /**
   * @generated from field: string cancellation_policy_text = 11;
   */
  cancellationPolicyText: string;

  /**
   * @generated from field: string support_email = 12;
   */
  supportEmail: string;

  /**
   * @generated from field: string support_phone = 13;
   */
  supportPhone: string;

  /**
   * @generated from field: string stripe_publishable_key = 14;
   */
  stripePublishableKey: string;

  /**
   * @generated from field: int64 minimum_client_hourly_rate_cents = 15;
   */
  minimumClientHourlyRateCents: bigint;

  /**
   * @generated from field: int64 recommended_client_hourly_rate_cents = 16;
   */
  recommendedClientHourlyRateCents: bigint;

  /**
   * @generated from field: int32 assignment_margin_basis_points = 17;
   */
  assignmentMarginBasisPoints: number;

  /**
   * @generated from field: int64 assignment_margin_cents = 18;
   */
  assignmentMarginCents: bigint;

  /**
   * @generated from field: string rate_guidance_text = 19;
   */
  rateGuidanceText: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetPublicSettingsResponse
 */
export type GetPublicSettingsResponseJson = {
  /**
   * @generated from field: bool service_enabled = 1;
   */
  serviceEnabled?: boolean;

  /**
   * @generated from field: int32 minimum_booking_minutes = 2;
   */
  minimumBookingMinutes?: number;

  /**
   * @generated from field: int32 booking_increment_minutes = 3;
   */
  bookingIncrementMinutes?: number;

  /**
   * @generated from field: int64 client_hourly_rate_cents = 4;
   */
  clientHourlyRateCents?: string;

  /**
   * @generated from field: guardianai.v1.familycare.TaxMode tax_mode = 5;
   */
  taxMode?: TaxModeJson;

  /**
   * @generated from field: int32 tax_rate_basis_points = 6;
   */
  taxRateBasisPoints?: number;

  /**
   * @generated from field: repeated string service_areas = 7;
   */
  serviceAreas?: string[];

  /**
   * @generated from field: string currency = 8;
   */
  currency?: string;

  /**
   * @generated from field: string terms_version = 9;
   */
  termsVersion?: string;

  /**
   * @generated from field: string privacy_notice_version = 10;
   */
  privacyNoticeVersion?: string;

  /**
   * @generated from field: string cancellation_policy_text = 11;
   */
  cancellationPolicyText?: string;

  /**
   * @generated from field: string support_email = 12;
   */
  supportEmail?: string;

  /**
   * @generated from field: string support_phone = 13;
   */
  supportPhone?: string;

  /**
   * @generated from field: string stripe_publishable_key = 14;
   */
  stripePublishableKey?: string;

  /**
   * @generated from field: int64 minimum_client_hourly_rate_cents = 15;
   */
  minimumClientHourlyRateCents?: string;

  /**
   * @generated from field: int64 recommended_client_hourly_rate_cents = 16;
   */
  recommendedClientHourlyRateCents?: string;

  /**
   * @generated from field: int32 assignment_margin_basis_points = 17;
   */
  assignmentMarginBasisPoints?: number;

  /**
   * @generated from field: int64 assignment_margin_cents = 18;
   */
  assignmentMarginCents?: string;

  /**
   * @generated from field: string rate_guidance_text = 19;
   */
  rateGuidanceText?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetPublicSettingsResponse.
 * Use `create(GetPublicSettingsResponseSchema)` to create a new message.
 */
export const GetPublicSettingsResponseSchema: GenMessage<GetPublicSettingsResponse, {jsonType: GetPublicSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 1);

/**
 * @generated from message guardianai.v1.familycare.CaregiverApplicationInput
 */
export type CaregiverApplicationInput = Message<"guardianai.v1.familycare.CaregiverApplicationInput"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone: string;

  /**
   * @generated from field: string city = 5;
   */
  city: string;

  /**
   * @generated from field: string province = 6;
   */
  province: string;

  /**
   * @generated from field: string postal_code = 7;
   */
  postalCode: string;

  /**
   * @generated from field: string desired_hours_per_week = 8;
   */
  desiredHoursPerWeek: string;

  /**
   * @generated from field: string availability = 9;
   */
  availability: string;

  /**
   * @generated from field: string childcare_experience = 10;
   */
  childcareExperience: string;

  /**
   * @generated from field: string certifications = 11;
   */
  certifications: string;

  /**
   * @generated from field: string languages = 12;
   */
  languages: string;

  /**
   * @generated from field: string work_authorization_status = 13;
   */
  workAuthorizationStatus: string;

  /**
   * @generated from field: bool can_provide_vulnerable_sector_check = 14;
   */
  canProvideVulnerableSectorCheck: boolean;

  /**
   * @generated from field: bool has_first_aid_cpr = 15;
   */
  hasFirstAidCpr: boolean;

  /**
   * @generated from field: bool has_childcare_experience = 16;
   */
  hasChildcareExperience: boolean;

  /**
   * @generated from field: bool background_check_consent = 17;
   */
  backgroundCheckConsent: boolean;

  /**
   * @generated from field: bool privacy_notice_accepted = 18;
   */
  privacyNoticeAccepted: boolean;
};

/**
 * @generated from message guardianai.v1.familycare.CaregiverApplicationInput
 */
export type CaregiverApplicationInputJson = {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName?: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: string email = 3;
   */
  email?: string;

  /**
   * @generated from field: string phone = 4;
   */
  phone?: string;

  /**
   * @generated from field: string city = 5;
   */
  city?: string;

  /**
   * @generated from field: string province = 6;
   */
  province?: string;

  /**
   * @generated from field: string postal_code = 7;
   */
  postalCode?: string;

  /**
   * @generated from field: string desired_hours_per_week = 8;
   */
  desiredHoursPerWeek?: string;

  /**
   * @generated from field: string availability = 9;
   */
  availability?: string;

  /**
   * @generated from field: string childcare_experience = 10;
   */
  childcareExperience?: string;

  /**
   * @generated from field: string certifications = 11;
   */
  certifications?: string;

  /**
   * @generated from field: string languages = 12;
   */
  languages?: string;

  /**
   * @generated from field: string work_authorization_status = 13;
   */
  workAuthorizationStatus?: string;

  /**
   * @generated from field: bool can_provide_vulnerable_sector_check = 14;
   */
  canProvideVulnerableSectorCheck?: boolean;

  /**
   * @generated from field: bool has_first_aid_cpr = 15;
   */
  hasFirstAidCpr?: boolean;

  /**
   * @generated from field: bool has_childcare_experience = 16;
   */
  hasChildcareExperience?: boolean;

  /**
   * @generated from field: bool background_check_consent = 17;
   */
  backgroundCheckConsent?: boolean;

  /**
   * @generated from field: bool privacy_notice_accepted = 18;
   */
  privacyNoticeAccepted?: boolean;
};

/**
 * Describes the message guardianai.v1.familycare.CaregiverApplicationInput.
 * Use `create(CaregiverApplicationInputSchema)` to create a new message.
 */
export const CaregiverApplicationInputSchema: GenMessage<CaregiverApplicationInput, {jsonType: CaregiverApplicationInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 2);

/**
 * @generated from message guardianai.v1.familycare.CaregiverApplication
 */
export type CaregiverApplication = Message<"guardianai.v1.familycare.CaregiverApplication"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string application_number = 2;
   */
  applicationNumber: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 3;
   */
  status: CaregiverApplicationStatus;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: string phone = 7;
   */
  phone: string;

  /**
   * @generated from field: string city = 8;
   */
  city: string;

  /**
   * @generated from field: string province = 9;
   */
  province: string;

  /**
   * @generated from field: string postal_code = 10;
   */
  postalCode: string;

  /**
   * @generated from field: string desired_hours_per_week = 11;
   */
  desiredHoursPerWeek: string;

  /**
   * @generated from field: string availability = 12;
   */
  availability: string;

  /**
   * @generated from field: string childcare_experience = 13;
   */
  childcareExperience: string;

  /**
   * @generated from field: string certifications = 14;
   */
  certifications: string;

  /**
   * @generated from field: string languages = 15;
   */
  languages: string;

  /**
   * @generated from field: string work_authorization_status = 16;
   */
  workAuthorizationStatus: string;

  /**
   * @generated from field: bool can_provide_vulnerable_sector_check = 17;
   */
  canProvideVulnerableSectorCheck: boolean;

  /**
   * @generated from field: bool has_first_aid_cpr = 18;
   */
  hasFirstAidCpr: boolean;

  /**
   * @generated from field: bool has_childcare_experience = 19;
   */
  hasChildcareExperience: boolean;

  /**
   * @generated from field: bool background_check_consent = 20;
   */
  backgroundCheckConsent: boolean;

  /**
   * @generated from field: int64 privacy_notice_accepted_at = 21;
   */
  privacyNoticeAcceptedAt: bigint;

  /**
   * @generated from field: string admin_notes = 22;
   */
  adminNotes: string;

  /**
   * @generated from field: string rejection_reason = 23;
   */
  rejectionReason: string;

  /**
   * @generated from field: int64 reviewed_at = 24;
   */
  reviewedAt: bigint;

  /**
   * @generated from field: string reviewed_by = 25;
   */
  reviewedBy: string;

  /**
   * @generated from field: int64 invited_at = 26;
   */
  invitedAt: bigint;

  /**
   * @generated from field: int64 invitation_expires_at = 27;
   */
  invitationExpiresAt: bigint;

  /**
   * @generated from field: string invited_by = 28;
   */
  invitedBy: string;

  /**
   * @generated from field: string invited_user_id = 29;
   */
  invitedUserId: string;

  /**
   * @generated from field: string hired_worker_id = 30;
   */
  hiredWorkerId: string;

  /**
   * @generated from field: int64 created_at = 31;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 32;
   */
  updatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.CaregiverApplication
 */
export type CaregiverApplicationJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string application_number = 2;
   */
  applicationNumber?: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 3;
   */
  status?: CaregiverApplicationStatusJson;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName?: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName?: string;

  /**
   * @generated from field: string email = 6;
   */
  email?: string;

  /**
   * @generated from field: string phone = 7;
   */
  phone?: string;

  /**
   * @generated from field: string city = 8;
   */
  city?: string;

  /**
   * @generated from field: string province = 9;
   */
  province?: string;

  /**
   * @generated from field: string postal_code = 10;
   */
  postalCode?: string;

  /**
   * @generated from field: string desired_hours_per_week = 11;
   */
  desiredHoursPerWeek?: string;

  /**
   * @generated from field: string availability = 12;
   */
  availability?: string;

  /**
   * @generated from field: string childcare_experience = 13;
   */
  childcareExperience?: string;

  /**
   * @generated from field: string certifications = 14;
   */
  certifications?: string;

  /**
   * @generated from field: string languages = 15;
   */
  languages?: string;

  /**
   * @generated from field: string work_authorization_status = 16;
   */
  workAuthorizationStatus?: string;

  /**
   * @generated from field: bool can_provide_vulnerable_sector_check = 17;
   */
  canProvideVulnerableSectorCheck?: boolean;

  /**
   * @generated from field: bool has_first_aid_cpr = 18;
   */
  hasFirstAidCpr?: boolean;

  /**
   * @generated from field: bool has_childcare_experience = 19;
   */
  hasChildcareExperience?: boolean;

  /**
   * @generated from field: bool background_check_consent = 20;
   */
  backgroundCheckConsent?: boolean;

  /**
   * @generated from field: int64 privacy_notice_accepted_at = 21;
   */
  privacyNoticeAcceptedAt?: string;

  /**
   * @generated from field: string admin_notes = 22;
   */
  adminNotes?: string;

  /**
   * @generated from field: string rejection_reason = 23;
   */
  rejectionReason?: string;

  /**
   * @generated from field: int64 reviewed_at = 24;
   */
  reviewedAt?: string;

  /**
   * @generated from field: string reviewed_by = 25;
   */
  reviewedBy?: string;

  /**
   * @generated from field: int64 invited_at = 26;
   */
  invitedAt?: string;

  /**
   * @generated from field: int64 invitation_expires_at = 27;
   */
  invitationExpiresAt?: string;

  /**
   * @generated from field: string invited_by = 28;
   */
  invitedBy?: string;

  /**
   * @generated from field: string invited_user_id = 29;
   */
  invitedUserId?: string;

  /**
   * @generated from field: string hired_worker_id = 30;
   */
  hiredWorkerId?: string;

  /**
   * @generated from field: int64 created_at = 31;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 32;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CaregiverApplication.
 * Use `create(CaregiverApplicationSchema)` to create a new message.
 */
export const CaregiverApplicationSchema: GenMessage<CaregiverApplication, {jsonType: CaregiverApplicationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 3);

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverApplicationRequest
 */
export type CreateCaregiverApplicationRequest = Message<"guardianai.v1.familycare.CreateCaregiverApplicationRequest"> & {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationInput application = 1;
   */
  application?: CaregiverApplicationInput;
};

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverApplicationRequest
 */
export type CreateCaregiverApplicationRequestJson = {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationInput application = 1;
   */
  application?: CaregiverApplicationInputJson;
};

/**
 * Describes the message guardianai.v1.familycare.CreateCaregiverApplicationRequest.
 * Use `create(CreateCaregiverApplicationRequestSchema)` to create a new message.
 */
export const CreateCaregiverApplicationRequestSchema: GenMessage<CreateCaregiverApplicationRequest, {jsonType: CreateCaregiverApplicationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 4);

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverApplicationResponse
 */
export type CreateCaregiverApplicationResponse = Message<"guardianai.v1.familycare.CreateCaregiverApplicationResponse"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string application_number = 2;
   */
  applicationNumber: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 3;
   */
  status: CaregiverApplicationStatus;
};

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverApplicationResponse
 */
export type CreateCaregiverApplicationResponseJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string application_number = 2;
   */
  applicationNumber?: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 3;
   */
  status?: CaregiverApplicationStatusJson;
};

/**
 * Describes the message guardianai.v1.familycare.CreateCaregiverApplicationResponse.
 * Use `create(CreateCaregiverApplicationResponseSchema)` to create a new message.
 */
export const CreateCaregiverApplicationResponseSchema: GenMessage<CreateCaregiverApplicationResponse, {jsonType: CreateCaregiverApplicationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 5);

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverInviteRequest
 */
export type GetCaregiverInviteRequest = Message<"guardianai.v1.familycare.GetCaregiverInviteRequest"> & {
  /**
   * @generated from field: string invite_token = 1;
   */
  inviteToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverInviteRequest
 */
export type GetCaregiverInviteRequestJson = {
  /**
   * @generated from field: string invite_token = 1;
   */
  inviteToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetCaregiverInviteRequest.
 * Use `create(GetCaregiverInviteRequestSchema)` to create a new message.
 */
export const GetCaregiverInviteRequestSchema: GenMessage<GetCaregiverInviteRequest, {jsonType: GetCaregiverInviteRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 6);

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverInviteResponse
 */
export type GetCaregiverInviteResponse = Message<"guardianai.v1.familycare.GetCaregiverInviteResponse"> & {
  /**
   * @generated from field: bool valid = 1;
   */
  valid: boolean;

  /**
   * @generated from field: string application_id = 2;
   */
  applicationId: string;

  /**
   * @generated from field: string application_number = 3;
   */
  applicationNumber: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: int64 invitation_expires_at = 7;
   */
  invitationExpiresAt: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 8;
   */
  status: CaregiverApplicationStatus;

  /**
   * @generated from field: string message = 9;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverInviteResponse
 */
export type GetCaregiverInviteResponseJson = {
  /**
   * @generated from field: bool valid = 1;
   */
  valid?: boolean;

  /**
   * @generated from field: string application_id = 2;
   */
  applicationId?: string;

  /**
   * @generated from field: string application_number = 3;
   */
  applicationNumber?: string;

  /**
   * @generated from field: string first_name = 4;
   */
  firstName?: string;

  /**
   * @generated from field: string last_name = 5;
   */
  lastName?: string;

  /**
   * @generated from field: string email = 6;
   */
  email?: string;

  /**
   * @generated from field: int64 invitation_expires_at = 7;
   */
  invitationExpiresAt?: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 8;
   */
  status?: CaregiverApplicationStatusJson;

  /**
   * @generated from field: string message = 9;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetCaregiverInviteResponse.
 * Use `create(GetCaregiverInviteResponseSchema)` to create a new message.
 */
export const GetCaregiverInviteResponseSchema: GenMessage<GetCaregiverInviteResponse, {jsonType: GetCaregiverInviteResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 7);

/**
 * @generated from message guardianai.v1.familycare.AddressInput
 */
export type AddressInput = Message<"guardianai.v1.familycare.AddressInput"> & {
  /**
   * @generated from field: string address_line_1 = 1;
   */
  addressLine1: string;

  /**
   * @generated from field: string address_line_2 = 2;
   */
  addressLine2: string;

  /**
   * @generated from field: string city = 3;
   */
  city: string;

  /**
   * @generated from field: string province = 4;
   */
  province: string;

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode: string;

  /**
   * @generated from field: string access_instructions = 6;
   */
  accessInstructions: string;

  /**
   * @generated from field: string parking_instructions = 7;
   */
  parkingInstructions: string;
};

/**
 * @generated from message guardianai.v1.familycare.AddressInput
 */
export type AddressInputJson = {
  /**
   * @generated from field: string address_line_1 = 1;
   */
  addressLine1?: string;

  /**
   * @generated from field: string address_line_2 = 2;
   */
  addressLine2?: string;

  /**
   * @generated from field: string city = 3;
   */
  city?: string;

  /**
   * @generated from field: string province = 4;
   */
  province?: string;

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode?: string;

  /**
   * @generated from field: string access_instructions = 6;
   */
  accessInstructions?: string;

  /**
   * @generated from field: string parking_instructions = 7;
   */
  parkingInstructions?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AddressInput.
 * Use `create(AddressInputSchema)` to create a new message.
 */
export const AddressInputSchema: GenMessage<AddressInput, {jsonType: AddressInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 8);

/**
 * @generated from message guardianai.v1.familycare.ChildInput
 */
export type ChildInput = Message<"guardianai.v1.familycare.ChildInput"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: int32 age_years = 2;
   */
  ageYears: number;

  /**
   * @generated from field: string allergies = 3;
   */
  allergies: string;

  /**
   * @generated from field: string medical_notes = 4;
   */
  medicalNotes: string;

  /**
   * @generated from field: string special_instructions = 5;
   */
  specialInstructions: string;

  /**
   * @generated from field: string emergency_notes = 6;
   */
  emergencyNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.ChildInput
 */
export type ChildInputJson = {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName?: string;

  /**
   * @generated from field: int32 age_years = 2;
   */
  ageYears?: number;

  /**
   * @generated from field: string allergies = 3;
   */
  allergies?: string;

  /**
   * @generated from field: string medical_notes = 4;
   */
  medicalNotes?: string;

  /**
   * @generated from field: string special_instructions = 5;
   */
  specialInstructions?: string;

  /**
   * @generated from field: string emergency_notes = 6;
   */
  emergencyNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ChildInput.
 * Use `create(ChildInputSchema)` to create a new message.
 */
export const ChildInputSchema: GenMessage<ChildInput, {jsonType: ChildInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 9);

/**
 * @generated from message guardianai.v1.familycare.EmergencyContactInput
 */
export type EmergencyContactInput = Message<"guardianai.v1.familycare.EmergencyContactInput"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone: string;

  /**
   * @generated from field: string relationship = 3;
   */
  relationship: string;
};

/**
 * @generated from message guardianai.v1.familycare.EmergencyContactInput
 */
export type EmergencyContactInputJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string phone = 2;
   */
  phone?: string;

  /**
   * @generated from field: string relationship = 3;
   */
  relationship?: string;
};

/**
 * Describes the message guardianai.v1.familycare.EmergencyContactInput.
 * Use `create(EmergencyContactInputSchema)` to create a new message.
 */
export const EmergencyContactInputSchema: GenMessage<EmergencyContactInput, {jsonType: EmergencyContactInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 10);

/**
 * @generated from message guardianai.v1.familycare.KnownCaregiverRequestInput
 */
export type KnownCaregiverRequestInput = Message<"guardianai.v1.familycare.KnownCaregiverRequestInput"> & {
  /**
   * @generated from field: string caregiver_name = 1;
   */
  caregiverName: string;

  /**
   * @generated from field: string caregiver_phone = 2;
   */
  caregiverPhone: string;

  /**
   * @generated from field: string caregiver_email = 3;
   */
  caregiverEmail: string;

  /**
   * @generated from field: string family_note = 4;
   */
  familyNote: string;
};

/**
 * @generated from message guardianai.v1.familycare.KnownCaregiverRequestInput
 */
export type KnownCaregiverRequestInputJson = {
  /**
   * @generated from field: string caregiver_name = 1;
   */
  caregiverName?: string;

  /**
   * @generated from field: string caregiver_phone = 2;
   */
  caregiverPhone?: string;

  /**
   * @generated from field: string caregiver_email = 3;
   */
  caregiverEmail?: string;

  /**
   * @generated from field: string family_note = 4;
   */
  familyNote?: string;
};

/**
 * Describes the message guardianai.v1.familycare.KnownCaregiverRequestInput.
 * Use `create(KnownCaregiverRequestInputSchema)` to create a new message.
 */
export const KnownCaregiverRequestInputSchema: GenMessage<KnownCaregiverRequestInput, {jsonType: KnownCaregiverRequestInputJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 11);

/**
 * @generated from message guardianai.v1.familycare.CreateBookingRequest
 */
export type CreateBookingRequest = Message<"guardianai.v1.familycare.CreateBookingRequest"> & {
  /**
   * @generated from field: string parent_first_name = 1;
   */
  parentFirstName: string;

  /**
   * @generated from field: string parent_last_name = 2;
   */
  parentLastName: string;

  /**
   * @generated from field: string parent_email = 3;
   */
  parentEmail: string;

  /**
   * @generated from field: string parent_phone = 4;
   */
  parentPhone: string;

  /**
   * @generated from field: string relationship_to_children = 5;
   */
  relationshipToChildren: string;

  /**
   * @generated from field: guardianai.v1.familycare.AddressInput service_address = 6;
   */
  serviceAddress?: AddressInput;

  /**
   * @generated from field: bool billing_address_same_as_service = 7;
   */
  billingAddressSameAsService: boolean;

  /**
   * @generated from field: guardianai.v1.familycare.AddressInput billing_address = 8;
   */
  billingAddress?: AddressInput;

  /**
   * @generated from field: int64 requested_start_at = 9;
   */
  requestedStartAt: bigint;

  /**
   * @generated from field: int64 requested_end_at = 10;
   */
  requestedEndAt: bigint;

  /**
   * @generated from field: repeated guardianai.v1.familycare.ChildInput children = 11;
   */
  children: ChildInput[];

  /**
   * @generated from field: guardianai.v1.familycare.EmergencyContactInput emergency_contact = 12;
   */
  emergencyContact?: EmergencyContactInput;

  /**
   * @generated from field: string service_type = 13;
   */
  serviceType: string;

  /**
   * @generated from field: string parent_notes = 14;
   */
  parentNotes: string;

  /**
   * @generated from field: bool parent_reachable_confirmed = 15;
   */
  parentReachableConfirmed: boolean;

  /**
   * @generated from field: bool terms_accepted = 16;
   */
  termsAccepted: boolean;

  /**
   * @generated from field: bool privacy_notice_accepted = 17;
   */
  privacyNoticeAccepted: boolean;

  /**
   * @generated from field: string terms_version = 18;
   */
  termsVersion: string;

  /**
   * @generated from field: string privacy_notice_version = 19;
   */
  privacyNoticeVersion: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 20;
   */
  clientOfferedHourlyRateCents: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestInput known_caregiver_request = 21;
   */
  knownCaregiverRequest?: KnownCaregiverRequestInput;
};

/**
 * @generated from message guardianai.v1.familycare.CreateBookingRequest
 */
export type CreateBookingRequestJson = {
  /**
   * @generated from field: string parent_first_name = 1;
   */
  parentFirstName?: string;

  /**
   * @generated from field: string parent_last_name = 2;
   */
  parentLastName?: string;

  /**
   * @generated from field: string parent_email = 3;
   */
  parentEmail?: string;

  /**
   * @generated from field: string parent_phone = 4;
   */
  parentPhone?: string;

  /**
   * @generated from field: string relationship_to_children = 5;
   */
  relationshipToChildren?: string;

  /**
   * @generated from field: guardianai.v1.familycare.AddressInput service_address = 6;
   */
  serviceAddress?: AddressInputJson;

  /**
   * @generated from field: bool billing_address_same_as_service = 7;
   */
  billingAddressSameAsService?: boolean;

  /**
   * @generated from field: guardianai.v1.familycare.AddressInput billing_address = 8;
   */
  billingAddress?: AddressInputJson;

  /**
   * @generated from field: int64 requested_start_at = 9;
   */
  requestedStartAt?: string;

  /**
   * @generated from field: int64 requested_end_at = 10;
   */
  requestedEndAt?: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.ChildInput children = 11;
   */
  children?: ChildInputJson[];

  /**
   * @generated from field: guardianai.v1.familycare.EmergencyContactInput emergency_contact = 12;
   */
  emergencyContact?: EmergencyContactInputJson;

  /**
   * @generated from field: string service_type = 13;
   */
  serviceType?: string;

  /**
   * @generated from field: string parent_notes = 14;
   */
  parentNotes?: string;

  /**
   * @generated from field: bool parent_reachable_confirmed = 15;
   */
  parentReachableConfirmed?: boolean;

  /**
   * @generated from field: bool terms_accepted = 16;
   */
  termsAccepted?: boolean;

  /**
   * @generated from field: bool privacy_notice_accepted = 17;
   */
  privacyNoticeAccepted?: boolean;

  /**
   * @generated from field: string terms_version = 18;
   */
  termsVersion?: string;

  /**
   * @generated from field: string privacy_notice_version = 19;
   */
  privacyNoticeVersion?: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 20;
   */
  clientOfferedHourlyRateCents?: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestInput known_caregiver_request = 21;
   */
  knownCaregiverRequest?: KnownCaregiverRequestInputJson;
};

/**
 * Describes the message guardianai.v1.familycare.CreateBookingRequest.
 * Use `create(CreateBookingRequestSchema)` to create a new message.
 */
export const CreateBookingRequestSchema: GenMessage<CreateBookingRequest, {jsonType: CreateBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 12);

/**
 * @generated from message guardianai.v1.familycare.CreateBookingResponse
 */
export type CreateBookingResponse = Message<"guardianai.v1.familycare.CreateBookingResponse"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 4;
   */
  status: BookingStatus;

  /**
   * @generated from field: int32 estimated_minutes = 5;
   */
  estimatedMinutes: number;

  /**
   * @generated from field: int64 subtotal_cents = 6;
   */
  subtotalCents: bigint;

  /**
   * @generated from field: int64 tax_cents = 7;
   */
  taxCents: bigint;

  /**
   * @generated from field: int64 total_cents = 8;
   */
  totalCents: bigint;

  /**
   * @generated from field: string currency = 9;
   */
  currency: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 10;
   */
  clientOfferedHourlyRateCents: bigint;

  /**
   * @generated from field: string rate_guidance = 11;
   */
  rateGuidance: string;

  /**
   * @generated from field: string known_caregiver_request_id = 12;
   */
  knownCaregiverRequestId: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateBookingResponse
 */
export type CreateBookingResponseJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber?: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 4;
   */
  status?: BookingStatusJson;

  /**
   * @generated from field: int32 estimated_minutes = 5;
   */
  estimatedMinutes?: number;

  /**
   * @generated from field: int64 subtotal_cents = 6;
   */
  subtotalCents?: string;

  /**
   * @generated from field: int64 tax_cents = 7;
   */
  taxCents?: string;

  /**
   * @generated from field: int64 total_cents = 8;
   */
  totalCents?: string;

  /**
   * @generated from field: string currency = 9;
   */
  currency?: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 10;
   */
  clientOfferedHourlyRateCents?: string;

  /**
   * @generated from field: string rate_guidance = 11;
   */
  rateGuidance?: string;

  /**
   * @generated from field: string known_caregiver_request_id = 12;
   */
  knownCaregiverRequestId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateBookingResponse.
 * Use `create(CreateBookingResponseSchema)` to create a new message.
 */
export const CreateBookingResponseSchema: GenMessage<CreateBookingResponse, {jsonType: CreateBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 13);

/**
 * @generated from message guardianai.v1.familycare.CreateBookingPaymentIntentRequest
 */
export type CreateBookingPaymentIntentRequest = Message<"guardianai.v1.familycare.CreateBookingPaymentIntentRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateBookingPaymentIntentRequest
 */
export type CreateBookingPaymentIntentRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateBookingPaymentIntentRequest.
 * Use `create(CreateBookingPaymentIntentRequestSchema)` to create a new message.
 */
export const CreateBookingPaymentIntentRequestSchema: GenMessage<CreateBookingPaymentIntentRequest, {jsonType: CreateBookingPaymentIntentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 14);

/**
 * @generated from message guardianai.v1.familycare.CreateBookingPaymentIntentResponse
 */
export type CreateBookingPaymentIntentResponse = Message<"guardianai.v1.familycare.CreateBookingPaymentIntentResponse"> & {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: string stripe_publishable_key = 5;
   */
  stripePublishableKey: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateBookingPaymentIntentResponse
 */
export type CreateBookingPaymentIntentResponseJson = {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret?: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * @generated from field: string stripe_publishable_key = 5;
   */
  stripePublishableKey?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateBookingPaymentIntentResponse.
 * Use `create(CreateBookingPaymentIntentResponseSchema)` to create a new message.
 */
export const CreateBookingPaymentIntentResponseSchema: GenMessage<CreateBookingPaymentIntentResponse, {jsonType: CreateBookingPaymentIntentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 15);

/**
 * @generated from message guardianai.v1.familycare.GetBookingStatusRequest
 */
export type GetBookingStatusRequest = Message<"guardianai.v1.familycare.GetBookingStatusRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetBookingStatusRequest
 */
export type GetBookingStatusRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetBookingStatusRequest.
 * Use `create(GetBookingStatusRequestSchema)` to create a new message.
 */
export const GetBookingStatusRequestSchema: GenMessage<GetBookingStatusRequest, {jsonType: GetBookingStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 16);

/**
 * @generated from message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptRequest
 */
export type PublicFamilyCareServiceDownloadReceiptRequest = Message<"guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptRequest
 */
export type PublicFamilyCareServiceDownloadReceiptRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId?: string;

  /**
   * @generated from field: string access_token = 3;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptRequest.
 * Use `create(PublicFamilyCareServiceDownloadReceiptRequestSchema)` to create a new message.
 */
export const PublicFamilyCareServiceDownloadReceiptRequestSchema: GenMessage<PublicFamilyCareServiceDownloadReceiptRequest, {jsonType: PublicFamilyCareServiceDownloadReceiptRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 17);

/**
 * @generated from message guardianai.v1.familycare.GetBookingStatusResponse
 */
export type GetBookingStatusResponse = Message<"guardianai.v1.familycare.GetBookingStatusResponse"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 3;
   */
  status: BookingStatus;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 4;
   */
  paymentStatus: PaymentStatus;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt: bigint;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 7;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: string currency = 8;
   */
  currency: string;

  /**
   * @generated from field: bool caregiver_assigned = 9;
   */
  caregiverAssigned: boolean;

  /**
   * @generated from field: bool receipt_ready = 10;
   */
  receiptReady: boolean;

  /**
   * @generated from field: string latest_receipt_id = 11;
   */
  latestReceiptId: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetBookingStatusResponse
 */
export type GetBookingStatusResponseJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 3;
   */
  status?: BookingStatusJson;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 4;
   */
  paymentStatus?: PaymentStatusJson;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt?: string;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt?: string;

  /**
   * @generated from field: int64 amount_paid_cents = 7;
   */
  amountPaidCents?: string;

  /**
   * @generated from field: string currency = 8;
   */
  currency?: string;

  /**
   * @generated from field: bool caregiver_assigned = 9;
   */
  caregiverAssigned?: boolean;

  /**
   * @generated from field: bool receipt_ready = 10;
   */
  receiptReady?: boolean;

  /**
   * @generated from field: string latest_receipt_id = 11;
   */
  latestReceiptId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetBookingStatusResponse.
 * Use `create(GetBookingStatusResponseSchema)` to create a new message.
 */
export const GetBookingStatusResponseSchema: GenMessage<GetBookingStatusResponse, {jsonType: GetBookingStatusResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 18);

/**
 * @generated from message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptResponse
 */
export type PublicFamilyCareServiceDownloadReceiptResponse = Message<"guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptResponse
 */
export type PublicFamilyCareServiceDownloadReceiptResponseJson = {
  /**
   * @generated from field: bytes data = 1;
   */
  data?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.familycare.PublicFamilyCareServiceDownloadReceiptResponse.
 * Use `create(PublicFamilyCareServiceDownloadReceiptResponseSchema)` to create a new message.
 */
export const PublicFamilyCareServiceDownloadReceiptResponseSchema: GenMessage<PublicFamilyCareServiceDownloadReceiptResponse, {jsonType: PublicFamilyCareServiceDownloadReceiptResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 19);

/**
 * @generated from message guardianai.v1.familycare.BookingChild
 */
export type BookingChild = Message<"guardianai.v1.familycare.BookingChild"> & {
  /**
   * @generated from field: string child_id = 1;
   */
  childId: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: int32 age_years = 3;
   */
  ageYears: number;

  /**
   * @generated from field: string allergies = 4;
   */
  allergies: string;

  /**
   * @generated from field: string medical_notes = 5;
   */
  medicalNotes: string;

  /**
   * @generated from field: string special_instructions = 6;
   */
  specialInstructions: string;

  /**
   * @generated from field: string emergency_notes = 7;
   */
  emergencyNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.BookingChild
 */
export type BookingChildJson = {
  /**
   * @generated from field: string child_id = 1;
   */
  childId?: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName?: string;

  /**
   * @generated from field: int32 age_years = 3;
   */
  ageYears?: number;

  /**
   * @generated from field: string allergies = 4;
   */
  allergies?: string;

  /**
   * @generated from field: string medical_notes = 5;
   */
  medicalNotes?: string;

  /**
   * @generated from field: string special_instructions = 6;
   */
  specialInstructions?: string;

  /**
   * @generated from field: string emergency_notes = 7;
   */
  emergencyNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.BookingChild.
 * Use `create(BookingChildSchema)` to create a new message.
 */
export const BookingChildSchema: GenMessage<BookingChild, {jsonType: BookingChildJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 20);

/**
 * @generated from message guardianai.v1.familycare.ServiceAddress
 */
export type ServiceAddress = Message<"guardianai.v1.familycare.ServiceAddress"> & {
  /**
   * @generated from field: string address_line_1 = 1;
   */
  addressLine1: string;

  /**
   * @generated from field: string address_line_2 = 2;
   */
  addressLine2: string;

  /**
   * @generated from field: string city = 3;
   */
  city: string;

  /**
   * @generated from field: string province = 4;
   */
  province: string;

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode: string;

  /**
   * @generated from field: string access_instructions = 6;
   */
  accessInstructions: string;

  /**
   * @generated from field: string parking_instructions = 7;
   */
  parkingInstructions: string;
};

/**
 * @generated from message guardianai.v1.familycare.ServiceAddress
 */
export type ServiceAddressJson = {
  /**
   * @generated from field: string address_line_1 = 1;
   */
  addressLine1?: string;

  /**
   * @generated from field: string address_line_2 = 2;
   */
  addressLine2?: string;

  /**
   * @generated from field: string city = 3;
   */
  city?: string;

  /**
   * @generated from field: string province = 4;
   */
  province?: string;

  /**
   * @generated from field: string postal_code = 5;
   */
  postalCode?: string;

  /**
   * @generated from field: string access_instructions = 6;
   */
  accessInstructions?: string;

  /**
   * @generated from field: string parking_instructions = 7;
   */
  parkingInstructions?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ServiceAddress.
 * Use `create(ServiceAddressSchema)` to create a new message.
 */
export const ServiceAddressSchema: GenMessage<ServiceAddress, {jsonType: ServiceAddressJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 21);

/**
 * @generated from message guardianai.v1.familycare.ParentBookingSummary
 */
export type ParentBookingSummary = Message<"guardianai.v1.familycare.ParentBookingSummary"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 3;
   */
  status: BookingStatus;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 4;
   */
  paymentStatus: PaymentStatus;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt: bigint;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt: bigint;

  /**
   * @generated from field: int64 total_cents = 7;
   */
  totalCents: bigint;

  /**
   * @generated from field: string currency = 8;
   */
  currency: string;

  /**
   * @generated from field: string service_city = 9;
   */
  serviceCity: string;

  /**
   * @generated from field: string latest_receipt_id = 10;
   */
  latestReceiptId: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 11;
   */
  clientOfferedHourlyRateCents: bigint;

  /**
   * @generated from field: string match_status_note = 12;
   */
  matchStatusNote: string;
};

/**
 * @generated from message guardianai.v1.familycare.ParentBookingSummary
 */
export type ParentBookingSummaryJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 3;
   */
  status?: BookingStatusJson;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 4;
   */
  paymentStatus?: PaymentStatusJson;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt?: string;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt?: string;

  /**
   * @generated from field: int64 total_cents = 7;
   */
  totalCents?: string;

  /**
   * @generated from field: string currency = 8;
   */
  currency?: string;

  /**
   * @generated from field: string service_city = 9;
   */
  serviceCity?: string;

  /**
   * @generated from field: string latest_receipt_id = 10;
   */
  latestReceiptId?: string;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 11;
   */
  clientOfferedHourlyRateCents?: string;

  /**
   * @generated from field: string match_status_note = 12;
   */
  matchStatusNote?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ParentBookingSummary.
 * Use `create(ParentBookingSummarySchema)` to create a new message.
 */
export const ParentBookingSummarySchema: GenMessage<ParentBookingSummary, {jsonType: ParentBookingSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 22);

/**
 * @generated from message guardianai.v1.familycare.ParentBooking
 */
export type ParentBooking = Message<"guardianai.v1.familycare.ParentBooking"> & {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBookingSummary summary = 1;
   */
  summary?: ParentBookingSummary;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 2;
   */
  serviceAddress?: ServiceAddress;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 3;
   */
  children: BookingChild[];

  /**
   * @generated from field: string emergency_contact_name = 4;
   */
  emergencyContactName: string;

  /**
   * @generated from field: string emergency_contact_phone = 5;
   */
  emergencyContactPhone: string;

  /**
   * @generated from field: string emergency_contact_relationship = 6;
   */
  emergencyContactRelationship: string;

  /**
   * @generated from field: string caregiver_display_name = 7;
   */
  caregiverDisplayName: string;

  /**
   * @generated from field: string care_summary = 8;
   */
  careSummary: string;

  /**
   * @generated from field: int64 checked_in_at = 9;
   */
  checkedInAt: bigint;

  /**
   * @generated from field: int64 checked_out_at = 10;
   */
  checkedOutAt: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest known_caregiver_request = 11;
   */
  knownCaregiverRequest?: KnownCaregiverRequest;
};

/**
 * @generated from message guardianai.v1.familycare.ParentBooking
 */
export type ParentBookingJson = {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBookingSummary summary = 1;
   */
  summary?: ParentBookingSummaryJson;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 2;
   */
  serviceAddress?: ServiceAddressJson;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 3;
   */
  children?: BookingChildJson[];

  /**
   * @generated from field: string emergency_contact_name = 4;
   */
  emergencyContactName?: string;

  /**
   * @generated from field: string emergency_contact_phone = 5;
   */
  emergencyContactPhone?: string;

  /**
   * @generated from field: string emergency_contact_relationship = 6;
   */
  emergencyContactRelationship?: string;

  /**
   * @generated from field: string caregiver_display_name = 7;
   */
  caregiverDisplayName?: string;

  /**
   * @generated from field: string care_summary = 8;
   */
  careSummary?: string;

  /**
   * @generated from field: int64 checked_in_at = 9;
   */
  checkedInAt?: string;

  /**
   * @generated from field: int64 checked_out_at = 10;
   */
  checkedOutAt?: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest known_caregiver_request = 11;
   */
  knownCaregiverRequest?: KnownCaregiverRequestJson;
};

/**
 * Describes the message guardianai.v1.familycare.ParentBooking.
 * Use `create(ParentBookingSchema)` to create a new message.
 */
export const ParentBookingSchema: GenMessage<ParentBooking, {jsonType: ParentBookingJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 23);

/**
 * @generated from message guardianai.v1.familycare.KnownCaregiverRequest
 */
export type KnownCaregiverRequest = Message<"guardianai.v1.familycare.KnownCaregiverRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestStatus status = 3;
   */
  status: KnownCaregiverRequestStatus;

  /**
   * @generated from field: string caregiver_name = 4;
   */
  caregiverName: string;

  /**
   * @generated from field: string caregiver_phone = 5;
   */
  caregiverPhone: string;

  /**
   * @generated from field: string caregiver_email = 6;
   */
  caregiverEmail: string;

  /**
   * @generated from field: string family_note = 7;
   */
  familyNote: string;

  /**
   * @generated from field: string operations_note = 8;
   */
  operationsNote: string;

  /**
   * @generated from field: string matched_worker_id = 9;
   */
  matchedWorkerId: string;

  /**
   * @generated from field: string matched_worker_name = 10;
   */
  matchedWorkerName: string;

  /**
   * @generated from field: int64 created_at = 11;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 reviewed_at = 12;
   */
  reviewedAt: bigint;

  /**
   * @generated from field: int64 caregiver_consented_at = 13;
   */
  caregiverConsentedAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.KnownCaregiverRequest
 */
export type KnownCaregiverRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestStatus status = 3;
   */
  status?: KnownCaregiverRequestStatusJson;

  /**
   * @generated from field: string caregiver_name = 4;
   */
  caregiverName?: string;

  /**
   * @generated from field: string caregiver_phone = 5;
   */
  caregiverPhone?: string;

  /**
   * @generated from field: string caregiver_email = 6;
   */
  caregiverEmail?: string;

  /**
   * @generated from field: string family_note = 7;
   */
  familyNote?: string;

  /**
   * @generated from field: string operations_note = 8;
   */
  operationsNote?: string;

  /**
   * @generated from field: string matched_worker_id = 9;
   */
  matchedWorkerId?: string;

  /**
   * @generated from field: string matched_worker_name = 10;
   */
  matchedWorkerName?: string;

  /**
   * @generated from field: int64 created_at = 11;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 reviewed_at = 12;
   */
  reviewedAt?: string;

  /**
   * @generated from field: int64 caregiver_consented_at = 13;
   */
  caregiverConsentedAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.KnownCaregiverRequest.
 * Use `create(KnownCaregiverRequestSchema)` to create a new message.
 */
export const KnownCaregiverRequestSchema: GenMessage<KnownCaregiverRequest, {jsonType: KnownCaregiverRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 24);

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingsRequest
 */
export type ListMyBookingsRequest = Message<"guardianai.v1.familycare.ListMyBookingsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingsRequest
 */
export type ListMyBookingsRequestJson = {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyBookingsRequest.
 * Use `create(ListMyBookingsRequestSchema)` to create a new message.
 */
export const ListMyBookingsRequestSchema: GenMessage<ListMyBookingsRequest, {jsonType: ListMyBookingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 25);

/**
 * @generated from message guardianai.v1.familycare.ClaimBookingRequest
 */
export type ClaimBookingRequest = Message<"guardianai.v1.familycare.ClaimBookingRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ClaimBookingRequest
 */
export type ClaimBookingRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ClaimBookingRequest.
 * Use `create(ClaimBookingRequestSchema)` to create a new message.
 */
export const ClaimBookingRequestSchema: GenMessage<ClaimBookingRequest, {jsonType: ClaimBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 26);

/**
 * @generated from message guardianai.v1.familycare.ClaimBookingResponse
 */
export type ClaimBookingResponse = Message<"guardianai.v1.familycare.ClaimBookingResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBooking booking = 1;
   */
  booking?: ParentBooking;
};

/**
 * @generated from message guardianai.v1.familycare.ClaimBookingResponse
 */
export type ClaimBookingResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBooking booking = 1;
   */
  booking?: ParentBookingJson;
};

/**
 * Describes the message guardianai.v1.familycare.ClaimBookingResponse.
 * Use `create(ClaimBookingResponseSchema)` to create a new message.
 */
export const ClaimBookingResponseSchema: GenMessage<ClaimBookingResponse, {jsonType: ClaimBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 27);

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingsResponse
 */
export type ListMyBookingsResponse = Message<"guardianai.v1.familycare.ListMyBookingsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.ParentBookingSummary bookings = 1;
   */
  bookings: ParentBookingSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingsResponse
 */
export type ListMyBookingsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.ParentBookingSummary bookings = 1;
   */
  bookings?: ParentBookingSummaryJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyBookingsResponse.
 * Use `create(ListMyBookingsResponseSchema)` to create a new message.
 */
export const ListMyBookingsResponseSchema: GenMessage<ListMyBookingsResponse, {jsonType: ListMyBookingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 28);

/**
 * @generated from message guardianai.v1.familycare.GetMyBookingRequest
 */
export type GetMyBookingRequest = Message<"guardianai.v1.familycare.GetMyBookingRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetMyBookingRequest
 */
export type GetMyBookingRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetMyBookingRequest.
 * Use `create(GetMyBookingRequestSchema)` to create a new message.
 */
export const GetMyBookingRequestSchema: GenMessage<GetMyBookingRequest, {jsonType: GetMyBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 29);

/**
 * @generated from message guardianai.v1.familycare.GetMyBookingResponse
 */
export type GetMyBookingResponse = Message<"guardianai.v1.familycare.GetMyBookingResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBooking booking = 1;
   */
  booking?: ParentBooking;
};

/**
 * @generated from message guardianai.v1.familycare.GetMyBookingResponse
 */
export type GetMyBookingResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.ParentBooking booking = 1;
   */
  booking?: ParentBookingJson;
};

/**
 * Describes the message guardianai.v1.familycare.GetMyBookingResponse.
 * Use `create(GetMyBookingResponseSchema)` to create a new message.
 */
export const GetMyBookingResponseSchema: GenMessage<GetMyBookingResponse, {jsonType: GetMyBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 30);

/**
 * @generated from message guardianai.v1.familycare.DownloadMyReceiptRequest
 */
export type DownloadMyReceiptRequest = Message<"guardianai.v1.familycare.DownloadMyReceiptRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId: string;
};

/**
 * @generated from message guardianai.v1.familycare.DownloadMyReceiptRequest
 */
export type DownloadMyReceiptRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.DownloadMyReceiptRequest.
 * Use `create(DownloadMyReceiptRequestSchema)` to create a new message.
 */
export const DownloadMyReceiptRequestSchema: GenMessage<DownloadMyReceiptRequest, {jsonType: DownloadMyReceiptRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 31);

/**
 * @generated from message guardianai.v1.familycare.DownloadMyReceiptResponse
 */
export type DownloadMyReceiptResponse = Message<"guardianai.v1.familycare.DownloadMyReceiptResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.familycare.DownloadMyReceiptResponse
 */
export type DownloadMyReceiptResponseJson = {
  /**
   * @generated from field: bytes data = 1;
   */
  data?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.familycare.DownloadMyReceiptResponse.
 * Use `create(DownloadMyReceiptResponseSchema)` to create a new message.
 */
export const DownloadMyReceiptResponseSchema: GenMessage<DownloadMyReceiptResponse, {jsonType: DownloadMyReceiptResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 32);

/**
 * @generated from message guardianai.v1.familycare.SubmitKnownCaregiverRequestRequest
 */
export type SubmitKnownCaregiverRequestRequest = Message<"guardianai.v1.familycare.SubmitKnownCaregiverRequestRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestInput request = 2;
   */
  request?: KnownCaregiverRequestInput;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitKnownCaregiverRequestRequest
 */
export type SubmitKnownCaregiverRequestRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestInput request = 2;
   */
  request?: KnownCaregiverRequestInputJson;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitKnownCaregiverRequestRequest.
 * Use `create(SubmitKnownCaregiverRequestRequestSchema)` to create a new message.
 */
export const SubmitKnownCaregiverRequestRequestSchema: GenMessage<SubmitKnownCaregiverRequestRequest, {jsonType: SubmitKnownCaregiverRequestRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 33);

/**
 * @generated from message guardianai.v1.familycare.SubmitKnownCaregiverRequestResponse
 */
export type SubmitKnownCaregiverRequestResponse = Message<"guardianai.v1.familycare.SubmitKnownCaregiverRequestResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest request = 1;
   */
  request?: KnownCaregiverRequest;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitKnownCaregiverRequestResponse
 */
export type SubmitKnownCaregiverRequestResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest request = 1;
   */
  request?: KnownCaregiverRequestJson;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitKnownCaregiverRequestResponse.
 * Use `create(SubmitKnownCaregiverRequestResponseSchema)` to create a new message.
 */
export const SubmitKnownCaregiverRequestResponseSchema: GenMessage<SubmitKnownCaregiverRequestResponse, {jsonType: SubmitKnownCaregiverRequestResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 34);

/**
 * @generated from message guardianai.v1.familycare.BookingMessage
 */
export type BookingMessage = Message<"guardianai.v1.familycare.BookingMessage"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingMessageSenderRole sender_role = 3;
   */
  senderRole: BookingMessageSenderRole;

  /**
   * @generated from field: string sender_display_name = 4;
   */
  senderDisplayName: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.BookingMessage
 */
export type BookingMessageJson = {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingMessageSenderRole sender_role = 3;
   */
  senderRole?: BookingMessageSenderRoleJson;

  /**
   * @generated from field: string sender_display_name = 4;
   */
  senderDisplayName?: string;

  /**
   * @generated from field: string body = 5;
   */
  body?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.BookingMessage.
 * Use `create(BookingMessageSchema)` to create a new message.
 */
export const BookingMessageSchema: GenMessage<BookingMessage, {jsonType: BookingMessageJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 35);

/**
 * @generated from message guardianai.v1.familycare.BookingExtension
 */
export type BookingExtension = Message<"guardianai.v1.familycare.BookingExtension"> & {
  /**
   * @generated from field: string extension_id = 1;
   */
  extensionId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: int32 additional_minutes = 3;
   */
  additionalMinutes: number;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingExtensionStatus status = 5;
   */
  status: BookingExtensionStatus;

  /**
   * @generated from field: int64 previous_end_at = 6;
   */
  previousEndAt: bigint;

  /**
   * @generated from field: int64 proposed_end_at = 7;
   */
  proposedEndAt: bigint;

  /**
   * @generated from field: int64 subtotal_cents = 8;
   */
  subtotalCents: bigint;

  /**
   * @generated from field: int64 tax_cents = 9;
   */
  taxCents: bigint;

  /**
   * @generated from field: int64 total_cents = 10;
   */
  totalCents: bigint;

  /**
   * @generated from field: string currency = 11;
   */
  currency: string;

  /**
   * @generated from field: int64 requested_at = 12;
   */
  requestedAt: bigint;

  /**
   * @generated from field: int64 responded_at = 13;
   */
  respondedAt: bigint;

  /**
   * @generated from field: int64 paid_at = 14;
   */
  paidAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.BookingExtension
 */
export type BookingExtensionJson = {
  /**
   * @generated from field: string extension_id = 1;
   */
  extensionId?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 additional_minutes = 3;
   */
  additionalMinutes?: number;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingExtensionStatus status = 5;
   */
  status?: BookingExtensionStatusJson;

  /**
   * @generated from field: int64 previous_end_at = 6;
   */
  previousEndAt?: string;

  /**
   * @generated from field: int64 proposed_end_at = 7;
   */
  proposedEndAt?: string;

  /**
   * @generated from field: int64 subtotal_cents = 8;
   */
  subtotalCents?: string;

  /**
   * @generated from field: int64 tax_cents = 9;
   */
  taxCents?: string;

  /**
   * @generated from field: int64 total_cents = 10;
   */
  totalCents?: string;

  /**
   * @generated from field: string currency = 11;
   */
  currency?: string;

  /**
   * @generated from field: int64 requested_at = 12;
   */
  requestedAt?: string;

  /**
   * @generated from field: int64 responded_at = 13;
   */
  respondedAt?: string;

  /**
   * @generated from field: int64 paid_at = 14;
   */
  paidAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.BookingExtension.
 * Use `create(BookingExtensionSchema)` to create a new message.
 */
export const BookingExtensionSchema: GenMessage<BookingExtension, {jsonType: BookingExtensionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 36);

/**
 * @generated from message guardianai.v1.familycare.ListBookingMessagesRequest
 */
export type ListBookingMessagesRequest = Message<"guardianai.v1.familycare.ListBookingMessagesRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListBookingMessagesRequest
 */
export type ListBookingMessagesRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListBookingMessagesRequest.
 * Use `create(ListBookingMessagesRequestSchema)` to create a new message.
 */
export const ListBookingMessagesRequestSchema: GenMessage<ListBookingMessagesRequest, {jsonType: ListBookingMessagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 37);

/**
 * @generated from message guardianai.v1.familycare.ListBookingMessagesResponse
 */
export type ListBookingMessagesResponse = Message<"guardianai.v1.familycare.ListBookingMessagesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages: BookingMessage[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions: BookingExtension[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListBookingMessagesResponse
 */
export type ListBookingMessagesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages?: BookingMessageJson[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions?: BookingExtensionJson[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListBookingMessagesResponse.
 * Use `create(ListBookingMessagesResponseSchema)` to create a new message.
 */
export const ListBookingMessagesResponseSchema: GenMessage<ListBookingMessagesResponse, {jsonType: ListBookingMessagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 38);

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingMessagesRequest
 */
export type ListMyBookingMessagesRequest = Message<"guardianai.v1.familycare.ListMyBookingMessagesRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingMessagesRequest
 */
export type ListMyBookingMessagesRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyBookingMessagesRequest.
 * Use `create(ListMyBookingMessagesRequestSchema)` to create a new message.
 */
export const ListMyBookingMessagesRequestSchema: GenMessage<ListMyBookingMessagesRequest, {jsonType: ListMyBookingMessagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 39);

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingMessagesResponse
 */
export type ListMyBookingMessagesResponse = Message<"guardianai.v1.familycare.ListMyBookingMessagesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages: BookingMessage[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions: BookingExtension[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyBookingMessagesResponse
 */
export type ListMyBookingMessagesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages?: BookingMessageJson[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions?: BookingExtensionJson[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyBookingMessagesResponse.
 * Use `create(ListMyBookingMessagesResponseSchema)` to create a new message.
 */
export const ListMyBookingMessagesResponseSchema: GenMessage<ListMyBookingMessagesResponse, {jsonType: ListMyBookingMessagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 40);

/**
 * @generated from message guardianai.v1.familycare.ListMyGigMessagesRequest
 */
export type ListMyGigMessagesRequest = Message<"guardianai.v1.familycare.ListMyGigMessagesRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyGigMessagesRequest
 */
export type ListMyGigMessagesRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyGigMessagesRequest.
 * Use `create(ListMyGigMessagesRequestSchema)` to create a new message.
 */
export const ListMyGigMessagesRequestSchema: GenMessage<ListMyGigMessagesRequest, {jsonType: ListMyGigMessagesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 41);

/**
 * @generated from message guardianai.v1.familycare.ListMyGigMessagesResponse
 */
export type ListMyGigMessagesResponse = Message<"guardianai.v1.familycare.ListMyGigMessagesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages: BookingMessage[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions: BookingExtension[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyGigMessagesResponse
 */
export type ListMyGigMessagesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingMessage messages = 1;
   */
  messages?: BookingMessageJson[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingExtension extensions = 2;
   */
  extensions?: BookingExtensionJson[];

  /**
   * @generated from field: string next_page_token = 3;
   */
  nextPageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyGigMessagesResponse.
 * Use `create(ListMyGigMessagesResponseSchema)` to create a new message.
 */
export const ListMyGigMessagesResponseSchema: GenMessage<ListMyGigMessagesResponse, {jsonType: ListMyGigMessagesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 42);

/**
 * @generated from message guardianai.v1.familycare.SendMyBookingMessageRequest
 */
export type SendMyBookingMessageRequest = Message<"guardianai.v1.familycare.SendMyBookingMessageRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;
};

/**
 * @generated from message guardianai.v1.familycare.SendMyBookingMessageRequest
 */
export type SendMyBookingMessageRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string body = 2;
   */
  body?: string;
};

/**
 * Describes the message guardianai.v1.familycare.SendMyBookingMessageRequest.
 * Use `create(SendMyBookingMessageRequestSchema)` to create a new message.
 */
export const SendMyBookingMessageRequestSchema: GenMessage<SendMyBookingMessageRequest, {jsonType: SendMyBookingMessageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 43);

/**
 * @generated from message guardianai.v1.familycare.SendMyBookingMessageResponse
 */
export type SendMyBookingMessageResponse = Message<"guardianai.v1.familycare.SendMyBookingMessageResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.BookingMessage message = 1;
   */
  message?: BookingMessage;
};

/**
 * @generated from message guardianai.v1.familycare.SendMyBookingMessageResponse
 */
export type SendMyBookingMessageResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.BookingMessage message = 1;
   */
  message?: BookingMessageJson;
};

/**
 * Describes the message guardianai.v1.familycare.SendMyBookingMessageResponse.
 * Use `create(SendMyBookingMessageResponseSchema)` to create a new message.
 */
export const SendMyBookingMessageResponseSchema: GenMessage<SendMyBookingMessageResponse, {jsonType: SendMyBookingMessageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 44);

/**
 * @generated from message guardianai.v1.familycare.SendMyGigMessageRequest
 */
export type SendMyGigMessageRequest = Message<"guardianai.v1.familycare.SendMyGigMessageRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;
};

/**
 * @generated from message guardianai.v1.familycare.SendMyGigMessageRequest
 */
export type SendMyGigMessageRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string body = 2;
   */
  body?: string;
};

/**
 * Describes the message guardianai.v1.familycare.SendMyGigMessageRequest.
 * Use `create(SendMyGigMessageRequestSchema)` to create a new message.
 */
export const SendMyGigMessageRequestSchema: GenMessage<SendMyGigMessageRequest, {jsonType: SendMyGigMessageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 45);

/**
 * @generated from message guardianai.v1.familycare.SendMyGigMessageResponse
 */
export type SendMyGigMessageResponse = Message<"guardianai.v1.familycare.SendMyGigMessageResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.BookingMessage message = 1;
   */
  message?: BookingMessage;
};

/**
 * @generated from message guardianai.v1.familycare.SendMyGigMessageResponse
 */
export type SendMyGigMessageResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.BookingMessage message = 1;
   */
  message?: BookingMessageJson;
};

/**
 * Describes the message guardianai.v1.familycare.SendMyGigMessageResponse.
 * Use `create(SendMyGigMessageResponseSchema)` to create a new message.
 */
export const SendMyGigMessageResponseSchema: GenMessage<SendMyGigMessageResponse, {jsonType: SendMyGigMessageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 46);

/**
 * @generated from message guardianai.v1.familycare.RequestBookingExtensionRequest
 */
export type RequestBookingExtensionRequest = Message<"guardianai.v1.familycare.RequestBookingExtensionRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: int32 additional_minutes = 2;
   */
  additionalMinutes: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.familycare.RequestBookingExtensionRequest
 */
export type RequestBookingExtensionRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 additional_minutes = 2;
   */
  additionalMinutes?: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.RequestBookingExtensionRequest.
 * Use `create(RequestBookingExtensionRequestSchema)` to create a new message.
 */
export const RequestBookingExtensionRequestSchema: GenMessage<RequestBookingExtensionRequest, {jsonType: RequestBookingExtensionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 47);

/**
 * @generated from message guardianai.v1.familycare.RequestBookingExtensionResponse
 */
export type RequestBookingExtensionResponse = Message<"guardianai.v1.familycare.RequestBookingExtensionResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.BookingExtension extension = 1;
   */
  extension?: BookingExtension;
};

/**
 * @generated from message guardianai.v1.familycare.RequestBookingExtensionResponse
 */
export type RequestBookingExtensionResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.BookingExtension extension = 1;
   */
  extension?: BookingExtensionJson;
};

/**
 * Describes the message guardianai.v1.familycare.RequestBookingExtensionResponse.
 * Use `create(RequestBookingExtensionResponseSchema)` to create a new message.
 */
export const RequestBookingExtensionResponseSchema: GenMessage<RequestBookingExtensionResponse, {jsonType: RequestBookingExtensionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 48);

/**
 * @generated from message guardianai.v1.familycare.RespondBookingExtensionRequest
 */
export type RespondBookingExtensionRequest = Message<"guardianai.v1.familycare.RespondBookingExtensionRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string extension_id = 2;
   */
  extensionId: string;

  /**
   * @generated from field: bool accept = 3;
   */
  accept: boolean;

  /**
   * @generated from field: string response_note = 4;
   */
  responseNote: string;
};

/**
 * @generated from message guardianai.v1.familycare.RespondBookingExtensionRequest
 */
export type RespondBookingExtensionRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string extension_id = 2;
   */
  extensionId?: string;

  /**
   * @generated from field: bool accept = 3;
   */
  accept?: boolean;

  /**
   * @generated from field: string response_note = 4;
   */
  responseNote?: string;
};

/**
 * Describes the message guardianai.v1.familycare.RespondBookingExtensionRequest.
 * Use `create(RespondBookingExtensionRequestSchema)` to create a new message.
 */
export const RespondBookingExtensionRequestSchema: GenMessage<RespondBookingExtensionRequest, {jsonType: RespondBookingExtensionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 49);

/**
 * @generated from message guardianai.v1.familycare.RespondBookingExtensionResponse
 */
export type RespondBookingExtensionResponse = Message<"guardianai.v1.familycare.RespondBookingExtensionResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.BookingExtension extension = 1;
   */
  extension?: BookingExtension;
};

/**
 * @generated from message guardianai.v1.familycare.RespondBookingExtensionResponse
 */
export type RespondBookingExtensionResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.BookingExtension extension = 1;
   */
  extension?: BookingExtensionJson;
};

/**
 * Describes the message guardianai.v1.familycare.RespondBookingExtensionResponse.
 * Use `create(RespondBookingExtensionResponseSchema)` to create a new message.
 */
export const RespondBookingExtensionResponseSchema: GenMessage<RespondBookingExtensionResponse, {jsonType: RespondBookingExtensionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 50);

/**
 * @generated from message guardianai.v1.familycare.CreateExtensionPaymentIntentRequest
 */
export type CreateExtensionPaymentIntentRequest = Message<"guardianai.v1.familycare.CreateExtensionPaymentIntentRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string extension_id = 2;
   */
  extensionId: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateExtensionPaymentIntentRequest
 */
export type CreateExtensionPaymentIntentRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string extension_id = 2;
   */
  extensionId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateExtensionPaymentIntentRequest.
 * Use `create(CreateExtensionPaymentIntentRequestSchema)` to create a new message.
 */
export const CreateExtensionPaymentIntentRequestSchema: GenMessage<CreateExtensionPaymentIntentRequest, {jsonType: CreateExtensionPaymentIntentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 51);

/**
 * @generated from message guardianai.v1.familycare.CreateExtensionPaymentIntentResponse
 */
export type CreateExtensionPaymentIntentResponse = Message<"guardianai.v1.familycare.CreateExtensionPaymentIntentResponse"> & {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: string stripe_publishable_key = 5;
   */
  stripePublishableKey: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateExtensionPaymentIntentResponse
 */
export type CreateExtensionPaymentIntentResponseJson = {
  /**
   * @generated from field: string payment_intent_id = 1;
   */
  paymentIntentId?: string;

  /**
   * @generated from field: string client_secret = 2;
   */
  clientSecret?: string;

  /**
   * @generated from field: int64 amount_cents = 3;
   */
  amountCents?: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * @generated from field: string stripe_publishable_key = 5;
   */
  stripePublishableKey?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateExtensionPaymentIntentResponse.
 * Use `create(CreateExtensionPaymentIntentResponseSchema)` to create a new message.
 */
export const CreateExtensionPaymentIntentResponseSchema: GenMessage<CreateExtensionPaymentIntentResponse, {jsonType: CreateExtensionPaymentIntentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 52);

/**
 * @generated from message guardianai.v1.familycare.WorkerGigSummary
 */
export type WorkerGigSummary = Message<"guardianai.v1.familycare.WorkerGigSummary"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus booking_status = 3;
   */
  bookingStatus: BookingStatus;

  /**
   * @generated from field: guardianai.v1.familycare.AssignmentStatus assignment_status = 4;
   */
  assignmentStatus: AssignmentStatus;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt: bigint;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt: bigint;

  /**
   * @generated from field: string service_city = 7;
   */
  serviceCity: string;

  /**
   * @generated from field: int32 number_of_children = 8;
   */
  numberOfChildren: number;

  /**
   * @generated from field: bool has_critical_notes = 9;
   */
  hasCriticalNotes: boolean;
};

/**
 * @generated from message guardianai.v1.familycare.WorkerGigSummary
 */
export type WorkerGigSummaryJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus booking_status = 3;
   */
  bookingStatus?: BookingStatusJson;

  /**
   * @generated from field: guardianai.v1.familycare.AssignmentStatus assignment_status = 4;
   */
  assignmentStatus?: AssignmentStatusJson;

  /**
   * @generated from field: int64 requested_start_at = 5;
   */
  requestedStartAt?: string;

  /**
   * @generated from field: int64 requested_end_at = 6;
   */
  requestedEndAt?: string;

  /**
   * @generated from field: string service_city = 7;
   */
  serviceCity?: string;

  /**
   * @generated from field: int32 number_of_children = 8;
   */
  numberOfChildren?: number;

  /**
   * @generated from field: bool has_critical_notes = 9;
   */
  hasCriticalNotes?: boolean;
};

/**
 * Describes the message guardianai.v1.familycare.WorkerGigSummary.
 * Use `create(WorkerGigSummarySchema)` to create a new message.
 */
export const WorkerGigSummarySchema: GenMessage<WorkerGigSummary, {jsonType: WorkerGigSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 53);

/**
 * @generated from message guardianai.v1.familycare.WorkerGigDetail
 */
export type WorkerGigDetail = Message<"guardianai.v1.familycare.WorkerGigDetail"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigSummary summary = 1;
   */
  summary?: WorkerGigSummary;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 2;
   */
  serviceAddress?: ServiceAddress;

  /**
   * @generated from field: string parent_name = 3;
   */
  parentName: string;

  /**
   * @generated from field: string parent_phone = 4;
   */
  parentPhone: string;

  /**
   * @generated from field: string emergency_contact_name = 5;
   */
  emergencyContactName: string;

  /**
   * @generated from field: string emergency_contact_phone = 6;
   */
  emergencyContactPhone: string;

  /**
   * @generated from field: string emergency_contact_relationship = 7;
   */
  emergencyContactRelationship: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 8;
   */
  children: BookingChild[];

  /**
   * @generated from field: string parent_notes = 9;
   */
  parentNotes: string;

  /**
   * @generated from field: int64 checked_in_at = 10;
   */
  checkedInAt: bigint;

  /**
   * @generated from field: int64 checked_out_at = 11;
   */
  checkedOutAt: bigint;

  /**
   * @generated from field: int32 actual_minutes = 12;
   */
  actualMinutes: number;

  /**
   * @generated from field: int32 payable_minutes = 13;
   */
  payableMinutes: number;

  /**
   * @generated from field: string care_summary = 14;
   */
  careSummary: string;

  /**
   * @generated from field: bool incident_flag = 15;
   */
  incidentFlag: boolean;
};

/**
 * @generated from message guardianai.v1.familycare.WorkerGigDetail
 */
export type WorkerGigDetailJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigSummary summary = 1;
   */
  summary?: WorkerGigSummaryJson;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 2;
   */
  serviceAddress?: ServiceAddressJson;

  /**
   * @generated from field: string parent_name = 3;
   */
  parentName?: string;

  /**
   * @generated from field: string parent_phone = 4;
   */
  parentPhone?: string;

  /**
   * @generated from field: string emergency_contact_name = 5;
   */
  emergencyContactName?: string;

  /**
   * @generated from field: string emergency_contact_phone = 6;
   */
  emergencyContactPhone?: string;

  /**
   * @generated from field: string emergency_contact_relationship = 7;
   */
  emergencyContactRelationship?: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 8;
   */
  children?: BookingChildJson[];

  /**
   * @generated from field: string parent_notes = 9;
   */
  parentNotes?: string;

  /**
   * @generated from field: int64 checked_in_at = 10;
   */
  checkedInAt?: string;

  /**
   * @generated from field: int64 checked_out_at = 11;
   */
  checkedOutAt?: string;

  /**
   * @generated from field: int32 actual_minutes = 12;
   */
  actualMinutes?: number;

  /**
   * @generated from field: int32 payable_minutes = 13;
   */
  payableMinutes?: number;

  /**
   * @generated from field: string care_summary = 14;
   */
  careSummary?: string;

  /**
   * @generated from field: bool incident_flag = 15;
   */
  incidentFlag?: boolean;
};

/**
 * Describes the message guardianai.v1.familycare.WorkerGigDetail.
 * Use `create(WorkerGigDetailSchema)` to create a new message.
 */
export const WorkerGigDetailSchema: GenMessage<WorkerGigDetail, {jsonType: WorkerGigDetailJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 54);

/**
 * @generated from message guardianai.v1.familycare.ListMyGigsRequest
 */
export type ListMyGigsRequest = Message<"guardianai.v1.familycare.ListMyGigsRequest"> & {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyGigsRequest
 */
export type ListMyGigsRequestJson = {
  /**
   * @generated from field: string status_filter = 1;
   */
  statusFilter?: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyGigsRequest.
 * Use `create(ListMyGigsRequestSchema)` to create a new message.
 */
export const ListMyGigsRequestSchema: GenMessage<ListMyGigsRequest, {jsonType: ListMyGigsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 55);

/**
 * @generated from message guardianai.v1.familycare.ListMyGigsResponse
 */
export type ListMyGigsResponse = Message<"guardianai.v1.familycare.ListMyGigsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerGigSummary gigs = 1;
   */
  gigs: WorkerGigSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 credential_expiry_count = 3;
   */
  credentialExpiryCount: number;

  /**
   * @generated from field: int32 current_payroll_minutes = 4;
   */
  currentPayrollMinutes: number;
};

/**
 * @generated from message guardianai.v1.familycare.ListMyGigsResponse
 */
export type ListMyGigsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerGigSummary gigs = 1;
   */
  gigs?: WorkerGigSummaryJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int32 credential_expiry_count = 3;
   */
  credentialExpiryCount?: number;

  /**
   * @generated from field: int32 current_payroll_minutes = 4;
   */
  currentPayrollMinutes?: number;
};

/**
 * Describes the message guardianai.v1.familycare.ListMyGigsResponse.
 * Use `create(ListMyGigsResponseSchema)` to create a new message.
 */
export const ListMyGigsResponseSchema: GenMessage<ListMyGigsResponse, {jsonType: ListMyGigsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 56);

/**
 * @generated from message guardianai.v1.familycare.GetMyGigRequest
 */
export type GetMyGigRequest = Message<"guardianai.v1.familycare.GetMyGigRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetMyGigRequest
 */
export type GetMyGigRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetMyGigRequest.
 * Use `create(GetMyGigRequestSchema)` to create a new message.
 */
export const GetMyGigRequestSchema: GenMessage<GetMyGigRequest, {jsonType: GetMyGigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 57);

/**
 * @generated from message guardianai.v1.familycare.GetMyGigResponse
 */
export type GetMyGigResponse = Message<"guardianai.v1.familycare.GetMyGigResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.GetMyGigResponse
 */
export type GetMyGigResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.GetMyGigResponse.
 * Use `create(GetMyGigResponseSchema)` to create a new message.
 */
export const GetMyGigResponseSchema: GenMessage<GetMyGigResponse, {jsonType: GetMyGigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 58);

/**
 * @generated from message guardianai.v1.familycare.AcceptAssignmentRequest
 */
export type AcceptAssignmentRequest = Message<"guardianai.v1.familycare.AcceptAssignmentRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;
};

/**
 * @generated from message guardianai.v1.familycare.AcceptAssignmentRequest
 */
export type AcceptAssignmentRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AcceptAssignmentRequest.
 * Use `create(AcceptAssignmentRequestSchema)` to create a new message.
 */
export const AcceptAssignmentRequestSchema: GenMessage<AcceptAssignmentRequest, {jsonType: AcceptAssignmentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 59);

/**
 * @generated from message guardianai.v1.familycare.AcceptAssignmentResponse
 */
export type AcceptAssignmentResponse = Message<"guardianai.v1.familycare.AcceptAssignmentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.AcceptAssignmentResponse
 */
export type AcceptAssignmentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.AcceptAssignmentResponse.
 * Use `create(AcceptAssignmentResponseSchema)` to create a new message.
 */
export const AcceptAssignmentResponseSchema: GenMessage<AcceptAssignmentResponse, {jsonType: AcceptAssignmentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 60);

/**
 * @generated from message guardianai.v1.familycare.DeclineAssignmentRequest
 */
export type DeclineAssignmentRequest = Message<"guardianai.v1.familycare.DeclineAssignmentRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.familycare.DeclineAssignmentRequest
 */
export type DeclineAssignmentRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.DeclineAssignmentRequest.
 * Use `create(DeclineAssignmentRequestSchema)` to create a new message.
 */
export const DeclineAssignmentRequestSchema: GenMessage<DeclineAssignmentRequest, {jsonType: DeclineAssignmentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 61);

/**
 * @generated from message guardianai.v1.familycare.DeclineAssignmentResponse
 */
export type DeclineAssignmentResponse = Message<"guardianai.v1.familycare.DeclineAssignmentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.DeclineAssignmentResponse
 */
export type DeclineAssignmentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.DeclineAssignmentResponse.
 * Use `create(DeclineAssignmentResponseSchema)` to create a new message.
 */
export const DeclineAssignmentResponseSchema: GenMessage<DeclineAssignmentResponse, {jsonType: DeclineAssignmentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 62);

/**
 * @generated from message guardianai.v1.familycare.VisitLocation
 */
export type VisitLocation = Message<"guardianai.v1.familycare.VisitLocation"> & {
  /**
   * @generated from field: bool worker_consented = 1;
   */
  workerConsented: boolean;

  /**
   * @generated from field: double latitude = 2;
   */
  latitude: number;

  /**
   * @generated from field: double longitude = 3;
   */
  longitude: number;
};

/**
 * @generated from message guardianai.v1.familycare.VisitLocation
 */
export type VisitLocationJson = {
  /**
   * @generated from field: bool worker_consented = 1;
   */
  workerConsented?: boolean;

  /**
   * @generated from field: double latitude = 2;
   */
  latitude?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double longitude = 3;
   */
  longitude?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.familycare.VisitLocation.
 * Use `create(VisitLocationSchema)` to create a new message.
 */
export const VisitLocationSchema: GenMessage<VisitLocation, {jsonType: VisitLocationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 63);

/**
 * @generated from message guardianai.v1.familycare.CheckInRequest
 */
export type CheckInRequest = Message<"guardianai.v1.familycare.CheckInRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: guardianai.v1.familycare.VisitLocation location = 2;
   */
  location?: VisitLocation;
};

/**
 * @generated from message guardianai.v1.familycare.CheckInRequest
 */
export type CheckInRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.VisitLocation location = 2;
   */
  location?: VisitLocationJson;
};

/**
 * Describes the message guardianai.v1.familycare.CheckInRequest.
 * Use `create(CheckInRequestSchema)` to create a new message.
 */
export const CheckInRequestSchema: GenMessage<CheckInRequest, {jsonType: CheckInRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 64);

/**
 * @generated from message guardianai.v1.familycare.CheckInResponse
 */
export type CheckInResponse = Message<"guardianai.v1.familycare.CheckInResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.CheckInResponse
 */
export type CheckInResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.CheckInResponse.
 * Use `create(CheckInResponseSchema)` to create a new message.
 */
export const CheckInResponseSchema: GenMessage<CheckInResponse, {jsonType: CheckInResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 65);

/**
 * @generated from message guardianai.v1.familycare.CheckOutRequest
 */
export type CheckOutRequest = Message<"guardianai.v1.familycare.CheckOutRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: guardianai.v1.familycare.VisitLocation location = 2;
   */
  location?: VisitLocation;

  /**
   * @generated from field: string care_summary = 3;
   */
  careSummary: string;
};

/**
 * @generated from message guardianai.v1.familycare.CheckOutRequest
 */
export type CheckOutRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.VisitLocation location = 2;
   */
  location?: VisitLocationJson;

  /**
   * @generated from field: string care_summary = 3;
   */
  careSummary?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CheckOutRequest.
 * Use `create(CheckOutRequestSchema)` to create a new message.
 */
export const CheckOutRequestSchema: GenMessage<CheckOutRequest, {jsonType: CheckOutRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 66);

/**
 * @generated from message guardianai.v1.familycare.CheckOutResponse
 */
export type CheckOutResponse = Message<"guardianai.v1.familycare.CheckOutResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.CheckOutResponse
 */
export type CheckOutResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.CheckOutResponse.
 * Use `create(CheckOutResponseSchema)` to create a new message.
 */
export const CheckOutResponseSchema: GenMessage<CheckOutResponse, {jsonType: CheckOutResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 67);

/**
 * @generated from message guardianai.v1.familycare.SubmitCareSummaryRequest
 */
export type SubmitCareSummaryRequest = Message<"guardianai.v1.familycare.SubmitCareSummaryRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string care_summary = 2;
   */
  careSummary: string;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitCareSummaryRequest
 */
export type SubmitCareSummaryRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string care_summary = 2;
   */
  careSummary?: string;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitCareSummaryRequest.
 * Use `create(SubmitCareSummaryRequestSchema)` to create a new message.
 */
export const SubmitCareSummaryRequestSchema: GenMessage<SubmitCareSummaryRequest, {jsonType: SubmitCareSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 68);

/**
 * @generated from message guardianai.v1.familycare.SubmitCareSummaryResponse
 */
export type SubmitCareSummaryResponse = Message<"guardianai.v1.familycare.SubmitCareSummaryResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetail;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitCareSummaryResponse
 */
export type SubmitCareSummaryResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerGigDetail gig = 1;
   */
  gig?: WorkerGigDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitCareSummaryResponse.
 * Use `create(SubmitCareSummaryResponseSchema)` to create a new message.
 */
export const SubmitCareSummaryResponseSchema: GenMessage<SubmitCareSummaryResponse, {jsonType: SubmitCareSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 69);

/**
 * @generated from message guardianai.v1.familycare.SubmitIncidentRequest
 */
export type SubmitIncidentRequest = Message<"guardianai.v1.familycare.SubmitIncidentRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string incident_type = 2;
   */
  incidentType: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool parent_notified = 4;
   */
  parentNotified: boolean;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitIncidentRequest
 */
export type SubmitIncidentRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string incident_type = 2;
   */
  incidentType?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool parent_notified = 4;
   */
  parentNotified?: boolean;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitIncidentRequest.
 * Use `create(SubmitIncidentRequestSchema)` to create a new message.
 */
export const SubmitIncidentRequestSchema: GenMessage<SubmitIncidentRequest, {jsonType: SubmitIncidentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 70);

/**
 * @generated from message guardianai.v1.familycare.SubmitIncidentResponse
 */
export type SubmitIncidentResponse = Message<"guardianai.v1.familycare.SubmitIncidentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.IncidentRecord incident = 1;
   */
  incident?: IncidentRecord;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitIncidentResponse
 */
export type SubmitIncidentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.IncidentRecord incident = 1;
   */
  incident?: IncidentRecordJson;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitIncidentResponse.
 * Use `create(SubmitIncidentResponseSchema)` to create a new message.
 */
export const SubmitIncidentResponseSchema: GenMessage<SubmitIncidentResponse, {jsonType: SubmitIncidentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 71);

/**
 * @generated from message guardianai.v1.familycare.ListMyOnboardingDocumentsRequest
 */
export type ListMyOnboardingDocumentsRequest = Message<"guardianai.v1.familycare.ListMyOnboardingDocumentsRequest"> & {
};

/**
 * @generated from message guardianai.v1.familycare.ListMyOnboardingDocumentsRequest
 */
export type ListMyOnboardingDocumentsRequestJson = {
};

/**
 * Describes the message guardianai.v1.familycare.ListMyOnboardingDocumentsRequest.
 * Use `create(ListMyOnboardingDocumentsRequestSchema)` to create a new message.
 */
export const ListMyOnboardingDocumentsRequestSchema: GenMessage<ListMyOnboardingDocumentsRequest, {jsonType: ListMyOnboardingDocumentsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 72);

/**
 * @generated from message guardianai.v1.familycare.ListMyOnboardingDocumentsResponse
 */
export type ListMyOnboardingDocumentsResponse = Message<"guardianai.v1.familycare.ListMyOnboardingDocumentsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerDocument documents = 1;
   */
  documents: WorkerDocument[];

  /**
   * @generated from field: bool federal_td1_complete = 2;
   */
  federalTd1Complete: boolean;

  /**
   * @generated from field: bool alberta_td1_complete = 3;
   */
  albertaTd1Complete: boolean;

  /**
   * @generated from field: bool direct_deposit_complete = 4;
   */
  directDepositComplete: boolean;

  /**
   * @generated from field: bool vulnerable_sector_check_complete = 5;
   */
  vulnerableSectorCheckComplete: boolean;

  /**
   * @generated from field: bool first_aid_cpr_complete = 6;
   */
  firstAidCprComplete: boolean;

  /**
   * @generated from field: bool employment_agreement_complete = 7;
   */
  employmentAgreementComplete: boolean;

  /**
   * @generated from field: bool work_permit_complete = 8;
   */
  workPermitComplete: boolean;

  /**
   * @generated from field: bool assignment_eligible = 9;
   */
  assignmentEligible: boolean;

  /**
   * @generated from field: repeated string assignment_blockers = 10;
   */
  assignmentBlockers: string[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerOnboardingTask onboarding_tasks = 11;
   */
  onboardingTasks: WorkerOnboardingTask[];
};

/**
 * @generated from message guardianai.v1.familycare.ListMyOnboardingDocumentsResponse
 */
export type ListMyOnboardingDocumentsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerDocument documents = 1;
   */
  documents?: WorkerDocumentJson[];

  /**
   * @generated from field: bool federal_td1_complete = 2;
   */
  federalTd1Complete?: boolean;

  /**
   * @generated from field: bool alberta_td1_complete = 3;
   */
  albertaTd1Complete?: boolean;

  /**
   * @generated from field: bool direct_deposit_complete = 4;
   */
  directDepositComplete?: boolean;

  /**
   * @generated from field: bool vulnerable_sector_check_complete = 5;
   */
  vulnerableSectorCheckComplete?: boolean;

  /**
   * @generated from field: bool first_aid_cpr_complete = 6;
   */
  firstAidCprComplete?: boolean;

  /**
   * @generated from field: bool employment_agreement_complete = 7;
   */
  employmentAgreementComplete?: boolean;

  /**
   * @generated from field: bool work_permit_complete = 8;
   */
  workPermitComplete?: boolean;

  /**
   * @generated from field: bool assignment_eligible = 9;
   */
  assignmentEligible?: boolean;

  /**
   * @generated from field: repeated string assignment_blockers = 10;
   */
  assignmentBlockers?: string[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerOnboardingTask onboarding_tasks = 11;
   */
  onboardingTasks?: WorkerOnboardingTaskJson[];
};

/**
 * Describes the message guardianai.v1.familycare.ListMyOnboardingDocumentsResponse.
 * Use `create(ListMyOnboardingDocumentsResponseSchema)` to create a new message.
 */
export const ListMyOnboardingDocumentsResponseSchema: GenMessage<ListMyOnboardingDocumentsResponse, {jsonType: ListMyOnboardingDocumentsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 73);

/**
 * @generated from message guardianai.v1.familycare.SubmitOnboardingDocumentRequest
 */
export type SubmitOnboardingDocumentRequest = Message<"guardianai.v1.familycare.SubmitOnboardingDocumentRequest"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 1;
   */
  documentType: WorkerDocumentType;

  /**
   * @generated from field: int32 tax_year = 2;
   */
  taxYear: number;

  /**
   * @generated from field: string original_filename = 3;
   */
  originalFilename: string;

  /**
   * @generated from field: bytes file_data = 4;
   */
  fileData: Uint8Array;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType: string;

  /**
   * @generated from field: bool employee_certifies_correct_and_complete = 6;
   */
  employeeCertifiesCorrectAndComplete: boolean;

  /**
   * @generated from field: bool payroll_purpose_notice_accepted = 7;
   */
  payrollPurposeNoticeAccepted: boolean;

  /**
   * @generated from field: string issue_date = 8;
   */
  issueDate: string;

  /**
   * @generated from field: string expiry_date = 9;
   */
  expiryDate: string;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitOnboardingDocumentRequest
 */
export type SubmitOnboardingDocumentRequestJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 1;
   */
  documentType?: WorkerDocumentTypeJson;

  /**
   * @generated from field: int32 tax_year = 2;
   */
  taxYear?: number;

  /**
   * @generated from field: string original_filename = 3;
   */
  originalFilename?: string;

  /**
   * @generated from field: bytes file_data = 4;
   */
  fileData?: string;

  /**
   * @generated from field: string content_type = 5;
   */
  contentType?: string;

  /**
   * @generated from field: bool employee_certifies_correct_and_complete = 6;
   */
  employeeCertifiesCorrectAndComplete?: boolean;

  /**
   * @generated from field: bool payroll_purpose_notice_accepted = 7;
   */
  payrollPurposeNoticeAccepted?: boolean;

  /**
   * @generated from field: string issue_date = 8;
   */
  issueDate?: string;

  /**
   * @generated from field: string expiry_date = 9;
   */
  expiryDate?: string;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitOnboardingDocumentRequest.
 * Use `create(SubmitOnboardingDocumentRequestSchema)` to create a new message.
 */
export const SubmitOnboardingDocumentRequestSchema: GenMessage<SubmitOnboardingDocumentRequest, {jsonType: SubmitOnboardingDocumentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 74);

/**
 * @generated from message guardianai.v1.familycare.SubmitOnboardingDocumentResponse
 */
export type SubmitOnboardingDocumentResponse = Message<"guardianai.v1.familycare.SubmitOnboardingDocumentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocument;
};

/**
 * @generated from message guardianai.v1.familycare.SubmitOnboardingDocumentResponse
 */
export type SubmitOnboardingDocumentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocumentJson;
};

/**
 * Describes the message guardianai.v1.familycare.SubmitOnboardingDocumentResponse.
 * Use `create(SubmitOnboardingDocumentResponseSchema)` to create a new message.
 */
export const SubmitOnboardingDocumentResponseSchema: GenMessage<SubmitOnboardingDocumentResponse, {jsonType: SubmitOnboardingDocumentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 75);

/**
 * @generated from message guardianai.v1.familycare.AcceptCaregiverInviteRequest
 */
export type AcceptCaregiverInviteRequest = Message<"guardianai.v1.familycare.AcceptCaregiverInviteRequest"> & {
  /**
   * @generated from field: string invite_token = 1;
   */
  inviteToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.AcceptCaregiverInviteRequest
 */
export type AcceptCaregiverInviteRequestJson = {
  /**
   * @generated from field: string invite_token = 1;
   */
  inviteToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AcceptCaregiverInviteRequest.
 * Use `create(AcceptCaregiverInviteRequestSchema)` to create a new message.
 */
export const AcceptCaregiverInviteRequestSchema: GenMessage<AcceptCaregiverInviteRequest, {jsonType: AcceptCaregiverInviteRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 76);

/**
 * @generated from message guardianai.v1.familycare.AcceptCaregiverInviteResponse
 */
export type AcceptCaregiverInviteResponse = Message<"guardianai.v1.familycare.AcceptCaregiverInviteResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerProfile worker = 1;
   */
  worker?: WorkerProfile;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 2;
   */
  application?: CaregiverApplication;
};

/**
 * @generated from message guardianai.v1.familycare.AcceptCaregiverInviteResponse
 */
export type AcceptCaregiverInviteResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerProfile worker = 1;
   */
  worker?: WorkerProfileJson;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 2;
   */
  application?: CaregiverApplicationJson;
};

/**
 * Describes the message guardianai.v1.familycare.AcceptCaregiverInviteResponse.
 * Use `create(AcceptCaregiverInviteResponseSchema)` to create a new message.
 */
export const AcceptCaregiverInviteResponseSchema: GenMessage<AcceptCaregiverInviteResponse, {jsonType: AcceptCaregiverInviteResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 77);

/**
 * @generated from message guardianai.v1.familycare.WorkerOnboardingTask
 */
export type WorkerOnboardingTask = Message<"guardianai.v1.familycare.WorkerOnboardingTask"> & {
  /**
   * @generated from field: string task_key = 1;
   */
  taskKey: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: bool complete = 4;
   */
  complete: boolean;

  /**
   * @generated from field: bool blocks_assignment = 5;
   */
  blocksAssignment: boolean;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string submitted_filename = 7;
   */
  submittedFilename: string;

  /**
   * @generated from field: int32 submitted_version = 8;
   */
  submittedVersion: number;

  /**
   * @generated from field: int64 submitted_at = 9;
   */
  submittedAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.WorkerOnboardingTask
 */
export type WorkerOnboardingTaskJson = {
  /**
   * @generated from field: string task_key = 1;
   */
  taskKey?: string;

  /**
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: bool complete = 4;
   */
  complete?: boolean;

  /**
   * @generated from field: bool blocks_assignment = 5;
   */
  blocksAssignment?: boolean;

  /**
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * @generated from field: string submitted_filename = 7;
   */
  submittedFilename?: string;

  /**
   * @generated from field: int32 submitted_version = 8;
   */
  submittedVersion?: number;

  /**
   * @generated from field: int64 submitted_at = 9;
   */
  submittedAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.WorkerOnboardingTask.
 * Use `create(WorkerOnboardingTaskSchema)` to create a new message.
 */
export const WorkerOnboardingTaskSchema: GenMessage<WorkerOnboardingTask, {jsonType: WorkerOnboardingTaskJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 78);

/**
 * @generated from message guardianai.v1.familycare.IncidentRecord
 */
export type IncidentRecord = Message<"guardianai.v1.familycare.IncidentRecord"> & {
  /**
   * @generated from field: string incident_id = 1;
   */
  incidentId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: string incident_type = 3;
   */
  incidentType: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: int64 parent_notified_at = 5;
   */
  parentNotifiedAt: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.IncidentStatus status = 6;
   */
  status: IncidentStatus;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.IncidentRecord
 */
export type IncidentRecordJson = {
  /**
   * @generated from field: string incident_id = 1;
   */
  incidentId?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: string incident_type = 3;
   */
  incidentType?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: int64 parent_notified_at = 5;
   */
  parentNotifiedAt?: string;

  /**
   * @generated from field: guardianai.v1.familycare.IncidentStatus status = 6;
   */
  status?: IncidentStatusJson;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.IncidentRecord.
 * Use `create(IncidentRecordSchema)` to create a new message.
 */
export const IncidentRecordSchema: GenMessage<IncidentRecord, {jsonType: IncidentRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 79);

/**
 * @generated from message guardianai.v1.familycare.GetDashboardRequest
 */
export type GetDashboardRequest = Message<"guardianai.v1.familycare.GetDashboardRequest"> & {
};

/**
 * @generated from message guardianai.v1.familycare.GetDashboardRequest
 */
export type GetDashboardRequestJson = {
};

/**
 * Describes the message guardianai.v1.familycare.GetDashboardRequest.
 * Use `create(GetDashboardRequestSchema)` to create a new message.
 */
export const GetDashboardRequestSchema: GenMessage<GetDashboardRequest, {jsonType: GetDashboardRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 80);

/**
 * @generated from message guardianai.v1.familycare.GetDashboardResponse
 */
export type GetDashboardResponse = Message<"guardianai.v1.familycare.GetDashboardResponse"> & {
  /**
   * @generated from field: int64 paid_pending_assignment = 1;
   */
  paidPendingAssignment: bigint;

  /**
   * @generated from field: int64 assigned = 2;
   */
  assigned: bigint;

  /**
   * @generated from field: int64 in_progress = 3;
   */
  inProgress: bigint;

  /**
   * @generated from field: int64 completed_pending_review = 4;
   */
  completedPendingReview: bigint;

  /**
   * @generated from field: int64 incidents_under_review = 5;
   */
  incidentsUnderReview: bigint;

  /**
   * @generated from field: int64 credentials_expiring_within_30_days = 6;
   */
  credentialsExpiringWithin30Days: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.GetDashboardResponse
 */
export type GetDashboardResponseJson = {
  /**
   * @generated from field: int64 paid_pending_assignment = 1;
   */
  paidPendingAssignment?: string;

  /**
   * @generated from field: int64 assigned = 2;
   */
  assigned?: string;

  /**
   * @generated from field: int64 in_progress = 3;
   */
  inProgress?: string;

  /**
   * @generated from field: int64 completed_pending_review = 4;
   */
  completedPendingReview?: string;

  /**
   * @generated from field: int64 incidents_under_review = 5;
   */
  incidentsUnderReview?: string;

  /**
   * @generated from field: int64 credentials_expiring_within_30_days = 6;
   */
  credentialsExpiringWithin30Days?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetDashboardResponse.
 * Use `create(GetDashboardResponseSchema)` to create a new message.
 */
export const GetDashboardResponseSchema: GenMessage<GetDashboardResponse, {jsonType: GetDashboardResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 81);

/**
 * @generated from message guardianai.v1.familycare.AdminBookingSummary
 */
export type AdminBookingSummary = Message<"guardianai.v1.familycare.AdminBookingSummary"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber: string;

  /**
   * @generated from field: string client_name = 3;
   */
  clientName: string;

  /**
   * @generated from field: int64 requested_start_at = 4;
   */
  requestedStartAt: bigint;

  /**
   * @generated from field: int64 requested_end_at = 5;
   */
  requestedEndAt: bigint;

  /**
   * @generated from field: string service_area = 6;
   */
  serviceArea: string;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 7;
   */
  paymentStatus: PaymentStatus;

  /**
   * @generated from field: string assigned_caregiver_name = 8;
   */
  assignedCaregiverName: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 9;
   */
  status: BookingStatus;

  /**
   * @generated from field: int64 amount_paid_cents = 10;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: string currency = 11;
   */
  currency: string;

  /**
   * @generated from field: bool payroll_approved = 12;
   */
  payrollApproved: boolean;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 13;
   */
  clientOfferedHourlyRateCents: bigint;

  /**
   * @generated from field: string match_status_note = 14;
   */
  matchStatusNote: string;
};

/**
 * @generated from message guardianai.v1.familycare.AdminBookingSummary
 */
export type AdminBookingSummaryJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string booking_number = 2;
   */
  bookingNumber?: string;

  /**
   * @generated from field: string client_name = 3;
   */
  clientName?: string;

  /**
   * @generated from field: int64 requested_start_at = 4;
   */
  requestedStartAt?: string;

  /**
   * @generated from field: int64 requested_end_at = 5;
   */
  requestedEndAt?: string;

  /**
   * @generated from field: string service_area = 6;
   */
  serviceArea?: string;

  /**
   * @generated from field: guardianai.v1.familycare.PaymentStatus payment_status = 7;
   */
  paymentStatus?: PaymentStatusJson;

  /**
   * @generated from field: string assigned_caregiver_name = 8;
   */
  assignedCaregiverName?: string;

  /**
   * @generated from field: guardianai.v1.familycare.BookingStatus status = 9;
   */
  status?: BookingStatusJson;

  /**
   * @generated from field: int64 amount_paid_cents = 10;
   */
  amountPaidCents?: string;

  /**
   * @generated from field: string currency = 11;
   */
  currency?: string;

  /**
   * @generated from field: bool payroll_approved = 12;
   */
  payrollApproved?: boolean;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 13;
   */
  clientOfferedHourlyRateCents?: string;

  /**
   * @generated from field: string match_status_note = 14;
   */
  matchStatusNote?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AdminBookingSummary.
 * Use `create(AdminBookingSummarySchema)` to create a new message.
 */
export const AdminBookingSummarySchema: GenMessage<AdminBookingSummary, {jsonType: AdminBookingSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 82);

/**
 * @generated from message guardianai.v1.familycare.ListBookingsRequest
 */
export type ListBookingsRequest = Message<"guardianai.v1.familycare.ListBookingsRequest"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingStatus statuses = 1;
   */
  statuses: BookingStatus[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery: string;

  /**
   * @generated from field: int64 starts_after = 3;
   */
  startsAfter: bigint;

  /**
   * @generated from field: int64 starts_before = 4;
   */
  startsBefore: bigint;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListBookingsRequest
 */
export type ListBookingsRequestJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingStatus statuses = 1;
   */
  statuses?: BookingStatusJson[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery?: string;

  /**
   * @generated from field: int64 starts_after = 3;
   */
  startsAfter?: string;

  /**
   * @generated from field: int64 starts_before = 4;
   */
  startsBefore?: string;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListBookingsRequest.
 * Use `create(ListBookingsRequestSchema)` to create a new message.
 */
export const ListBookingsRequestSchema: GenMessage<ListBookingsRequest, {jsonType: ListBookingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 83);

/**
 * @generated from message guardianai.v1.familycare.ListBookingsResponse
 */
export type ListBookingsResponse = Message<"guardianai.v1.familycare.ListBookingsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.AdminBookingSummary bookings = 1;
   */
  bookings: AdminBookingSummary[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.ListBookingsResponse
 */
export type ListBookingsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.AdminBookingSummary bookings = 1;
   */
  bookings?: AdminBookingSummaryJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListBookingsResponse.
 * Use `create(ListBookingsResponseSchema)` to create a new message.
 */
export const ListBookingsResponseSchema: GenMessage<ListBookingsResponse, {jsonType: ListBookingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 84);

/**
 * @generated from message guardianai.v1.familycare.GetBookingRequest
 */
export type GetBookingRequest = Message<"guardianai.v1.familycare.GetBookingRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetBookingRequest
 */
export type GetBookingRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetBookingRequest.
 * Use `create(GetBookingRequestSchema)` to create a new message.
 */
export const GetBookingRequestSchema: GenMessage<GetBookingRequest, {jsonType: GetBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 85);

/**
 * @generated from message guardianai.v1.familycare.GetBookingResponse
 */
export type GetBookingResponse = Message<"guardianai.v1.familycare.GetBookingResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.GetBookingResponse
 */
export type GetBookingResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.GetBookingResponse.
 * Use `create(GetBookingResponseSchema)` to create a new message.
 */
export const GetBookingResponseSchema: GenMessage<GetBookingResponse, {jsonType: GetBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 86);

/**
 * @generated from message guardianai.v1.familycare.ListCaregiverApplicationsRequest
 */
export type ListCaregiverApplicationsRequest = Message<"guardianai.v1.familycare.ListCaregiverApplicationsRequest"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.CaregiverApplicationStatus statuses = 1;
   */
  statuses: CaregiverApplicationStatus[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListCaregiverApplicationsRequest
 */
export type ListCaregiverApplicationsRequestJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.CaregiverApplicationStatus statuses = 1;
   */
  statuses?: CaregiverApplicationStatusJson[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery?: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListCaregiverApplicationsRequest.
 * Use `create(ListCaregiverApplicationsRequestSchema)` to create a new message.
 */
export const ListCaregiverApplicationsRequestSchema: GenMessage<ListCaregiverApplicationsRequest, {jsonType: ListCaregiverApplicationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 87);

/**
 * @generated from message guardianai.v1.familycare.ListCaregiverApplicationsResponse
 */
export type ListCaregiverApplicationsResponse = Message<"guardianai.v1.familycare.ListCaregiverApplicationsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.CaregiverApplication applications = 1;
   */
  applications: CaregiverApplication[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.ListCaregiverApplicationsResponse
 */
export type ListCaregiverApplicationsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.CaregiverApplication applications = 1;
   */
  applications?: CaregiverApplicationJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListCaregiverApplicationsResponse.
 * Use `create(ListCaregiverApplicationsResponseSchema)` to create a new message.
 */
export const ListCaregiverApplicationsResponseSchema: GenMessage<ListCaregiverApplicationsResponse, {jsonType: ListCaregiverApplicationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 88);

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverApplicationRequest
 */
export type GetCaregiverApplicationRequest = Message<"guardianai.v1.familycare.GetCaregiverApplicationRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;
};

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverApplicationRequest
 */
export type GetCaregiverApplicationRequestJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GetCaregiverApplicationRequest.
 * Use `create(GetCaregiverApplicationRequestSchema)` to create a new message.
 */
export const GetCaregiverApplicationRequestSchema: GenMessage<GetCaregiverApplicationRequest, {jsonType: GetCaregiverApplicationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 89);

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverApplicationResponse
 */
export type GetCaregiverApplicationResponse = Message<"guardianai.v1.familycare.GetCaregiverApplicationResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplication;
};

/**
 * @generated from message guardianai.v1.familycare.GetCaregiverApplicationResponse
 */
export type GetCaregiverApplicationResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplicationJson;
};

/**
 * Describes the message guardianai.v1.familycare.GetCaregiverApplicationResponse.
 * Use `create(GetCaregiverApplicationResponseSchema)` to create a new message.
 */
export const GetCaregiverApplicationResponseSchema: GenMessage<GetCaregiverApplicationResponse, {jsonType: GetCaregiverApplicationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 90);

/**
 * @generated from message guardianai.v1.familycare.UpdateCaregiverApplicationRequest
 */
export type UpdateCaregiverApplicationRequest = Message<"guardianai.v1.familycare.UpdateCaregiverApplicationRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 2;
   */
  status: CaregiverApplicationStatus;

  /**
   * @generated from field: string admin_notes = 3;
   */
  adminNotes: string;

  /**
   * @generated from field: string rejection_reason = 4;
   */
  rejectionReason: string;
};

/**
 * @generated from message guardianai.v1.familycare.UpdateCaregiverApplicationRequest
 */
export type UpdateCaregiverApplicationRequestJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplicationStatus status = 2;
   */
  status?: CaregiverApplicationStatusJson;

  /**
   * @generated from field: string admin_notes = 3;
   */
  adminNotes?: string;

  /**
   * @generated from field: string rejection_reason = 4;
   */
  rejectionReason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.UpdateCaregiverApplicationRequest.
 * Use `create(UpdateCaregiverApplicationRequestSchema)` to create a new message.
 */
export const UpdateCaregiverApplicationRequestSchema: GenMessage<UpdateCaregiverApplicationRequest, {jsonType: UpdateCaregiverApplicationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 91);

/**
 * @generated from message guardianai.v1.familycare.UpdateCaregiverApplicationResponse
 */
export type UpdateCaregiverApplicationResponse = Message<"guardianai.v1.familycare.UpdateCaregiverApplicationResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplication;
};

/**
 * @generated from message guardianai.v1.familycare.UpdateCaregiverApplicationResponse
 */
export type UpdateCaregiverApplicationResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplicationJson;
};

/**
 * Describes the message guardianai.v1.familycare.UpdateCaregiverApplicationResponse.
 * Use `create(UpdateCaregiverApplicationResponseSchema)` to create a new message.
 */
export const UpdateCaregiverApplicationResponseSchema: GenMessage<UpdateCaregiverApplicationResponse, {jsonType: UpdateCaregiverApplicationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 92);

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverInvitationRequest
 */
export type CreateCaregiverInvitationRequest = Message<"guardianai.v1.familycare.CreateCaregiverInvitationRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string employee_code = 2;
   */
  employeeCode: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 3;
   */
  hourlyRateCents: bigint;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 4;
   */
  vacationPayBasisPoints: number;

  /**
   * @generated from field: string employment_type = 5;
   */
  employmentType: string;

  /**
   * @generated from field: string hire_date = 6;
   */
  hireDate: string;

  /**
   * @generated from field: string admin_notes = 7;
   */
  adminNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverInvitationRequest
 */
export type CreateCaregiverInvitationRequestJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string employee_code = 2;
   */
  employeeCode?: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 3;
   */
  hourlyRateCents?: string;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 4;
   */
  vacationPayBasisPoints?: number;

  /**
   * @generated from field: string employment_type = 5;
   */
  employmentType?: string;

  /**
   * @generated from field: string hire_date = 6;
   */
  hireDate?: string;

  /**
   * @generated from field: string admin_notes = 7;
   */
  adminNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateCaregiverInvitationRequest.
 * Use `create(CreateCaregiverInvitationRequestSchema)` to create a new message.
 */
export const CreateCaregiverInvitationRequestSchema: GenMessage<CreateCaregiverInvitationRequest, {jsonType: CreateCaregiverInvitationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 93);

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverInvitationResponse
 */
export type CreateCaregiverInvitationResponse = Message<"guardianai.v1.familycare.CreateCaregiverInvitationResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplication;

  /**
   * @generated from field: string invite_url = 2;
   */
  inviteUrl: string;

  /**
   * @generated from field: int64 invitation_expires_at = 3;
   */
  invitationExpiresAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.CreateCaregiverInvitationResponse
 */
export type CreateCaregiverInvitationResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.CaregiverApplication application = 1;
   */
  application?: CaregiverApplicationJson;

  /**
   * @generated from field: string invite_url = 2;
   */
  inviteUrl?: string;

  /**
   * @generated from field: int64 invitation_expires_at = 3;
   */
  invitationExpiresAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CreateCaregiverInvitationResponse.
 * Use `create(CreateCaregiverInvitationResponseSchema)` to create a new message.
 */
export const CreateCaregiverInvitationResponseSchema: GenMessage<CreateCaregiverInvitationResponse, {jsonType: CreateCaregiverInvitationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 94);

/**
 * @generated from message guardianai.v1.familycare.ListKnownCaregiverRequestsRequest
 */
export type ListKnownCaregiverRequestsRequest = Message<"guardianai.v1.familycare.ListKnownCaregiverRequestsRequest"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.KnownCaregiverRequestStatus statuses = 1;
   */
  statuses: KnownCaregiverRequestStatus[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListKnownCaregiverRequestsRequest
 */
export type ListKnownCaregiverRequestsRequestJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.KnownCaregiverRequestStatus statuses = 1;
   */
  statuses?: KnownCaregiverRequestStatusJson[];

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery?: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId?: string;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 5;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListKnownCaregiverRequestsRequest.
 * Use `create(ListKnownCaregiverRequestsRequestSchema)` to create a new message.
 */
export const ListKnownCaregiverRequestsRequestSchema: GenMessage<ListKnownCaregiverRequestsRequest, {jsonType: ListKnownCaregiverRequestsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 95);

/**
 * @generated from message guardianai.v1.familycare.ListKnownCaregiverRequestsResponse
 */
export type ListKnownCaregiverRequestsResponse = Message<"guardianai.v1.familycare.ListKnownCaregiverRequestsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.KnownCaregiverRequest requests = 1;
   */
  requests: KnownCaregiverRequest[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.ListKnownCaregiverRequestsResponse
 */
export type ListKnownCaregiverRequestsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.KnownCaregiverRequest requests = 1;
   */
  requests?: KnownCaregiverRequestJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListKnownCaregiverRequestsResponse.
 * Use `create(ListKnownCaregiverRequestsResponseSchema)` to create a new message.
 */
export const ListKnownCaregiverRequestsResponseSchema: GenMessage<ListKnownCaregiverRequestsResponse, {jsonType: ListKnownCaregiverRequestsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 96);

/**
 * @generated from message guardianai.v1.familycare.ReviewKnownCaregiverRequestRequest
 */
export type ReviewKnownCaregiverRequestRequest = Message<"guardianai.v1.familycare.ReviewKnownCaregiverRequestRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestStatus status = 2;
   */
  status: KnownCaregiverRequestStatus;

  /**
   * @generated from field: string matched_worker_id = 3;
   */
  matchedWorkerId: string;

  /**
   * @generated from field: string operations_note = 4;
   */
  operationsNote: string;

  /**
   * @generated from field: bool caregiver_consented = 5;
   */
  caregiverConsented: boolean;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewKnownCaregiverRequestRequest
 */
export type ReviewKnownCaregiverRequestRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequestStatus status = 2;
   */
  status?: KnownCaregiverRequestStatusJson;

  /**
   * @generated from field: string matched_worker_id = 3;
   */
  matchedWorkerId?: string;

  /**
   * @generated from field: string operations_note = 4;
   */
  operationsNote?: string;

  /**
   * @generated from field: bool caregiver_consented = 5;
   */
  caregiverConsented?: boolean;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewKnownCaregiverRequestRequest.
 * Use `create(ReviewKnownCaregiverRequestRequestSchema)` to create a new message.
 */
export const ReviewKnownCaregiverRequestRequestSchema: GenMessage<ReviewKnownCaregiverRequestRequest, {jsonType: ReviewKnownCaregiverRequestRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 97);

/**
 * @generated from message guardianai.v1.familycare.ReviewKnownCaregiverRequestResponse
 */
export type ReviewKnownCaregiverRequestResponse = Message<"guardianai.v1.familycare.ReviewKnownCaregiverRequestResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest request = 1;
   */
  request?: KnownCaregiverRequest;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewKnownCaregiverRequestResponse
 */
export type ReviewKnownCaregiverRequestResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest request = 1;
   */
  request?: KnownCaregiverRequestJson;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewKnownCaregiverRequestResponse.
 * Use `create(ReviewKnownCaregiverRequestResponseSchema)` to create a new message.
 */
export const ReviewKnownCaregiverRequestResponseSchema: GenMessage<ReviewKnownCaregiverRequestResponse, {jsonType: ReviewKnownCaregiverRequestResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 98);

/**
 * @generated from message guardianai.v1.familycare.AdminBookingDetail
 */
export type AdminBookingDetail = Message<"guardianai.v1.familycare.AdminBookingDetail"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingSummary summary = 1;
   */
  summary?: AdminBookingSummary;

  /**
   * @generated from field: string client_email = 2;
   */
  clientEmail: string;

  /**
   * @generated from field: string client_phone = 3;
   */
  clientPhone: string;

  /**
   * @generated from field: string relationship_to_children = 4;
   */
  relationshipToChildren: string;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 5;
   */
  serviceAddress?: ServiceAddress;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 6;
   */
  children: BookingChild[];

  /**
   * @generated from field: string emergency_contact_name = 7;
   */
  emergencyContactName: string;

  /**
   * @generated from field: string emergency_contact_phone = 8;
   */
  emergencyContactPhone: string;

  /**
   * @generated from field: string emergency_contact_relationship = 9;
   */
  emergencyContactRelationship: string;

  /**
   * @generated from field: string parent_notes = 10;
   */
  parentNotes: string;

  /**
   * @generated from field: string admin_notes = 11;
   */
  adminNotes: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 12;
   */
  stripePaymentIntentId: string;

  /**
   * @generated from field: int64 subtotal_cents = 13;
   */
  subtotalCents: bigint;

  /**
   * @generated from field: int64 tax_cents = 14;
   */
  taxCents: bigint;

  /**
   * @generated from field: guardianai.v1.familycare.AssignmentStatus assignment_status = 15;
   */
  assignmentStatus: AssignmentStatus;

  /**
   * @generated from field: string assigned_worker_id = 16;
   */
  assignedWorkerId: string;

  /**
   * @generated from field: int64 checked_in_at = 17;
   */
  checkedInAt: bigint;

  /**
   * @generated from field: int64 checked_out_at = 18;
   */
  checkedOutAt: bigint;

  /**
   * @generated from field: int32 actual_minutes = 19;
   */
  actualMinutes: number;

  /**
   * @generated from field: int32 payable_minutes = 20;
   */
  payableMinutes: number;

  /**
   * @generated from field: string care_summary = 21;
   */
  careSummary: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.IncidentRecord incidents = 22;
   */
  incidents: IncidentRecord[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.ReceiptRecord receipts = 23;
   */
  receipts: ReceiptRecord[];

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest known_caregiver_request = 24;
   */
  knownCaregiverRequest?: KnownCaregiverRequest;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 25;
   */
  clientOfferedHourlyRateCents: bigint;

  /**
   * @generated from field: string match_status_note = 26;
   */
  matchStatusNote: string;
};

/**
 * @generated from message guardianai.v1.familycare.AdminBookingDetail
 */
export type AdminBookingDetailJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingSummary summary = 1;
   */
  summary?: AdminBookingSummaryJson;

  /**
   * @generated from field: string client_email = 2;
   */
  clientEmail?: string;

  /**
   * @generated from field: string client_phone = 3;
   */
  clientPhone?: string;

  /**
   * @generated from field: string relationship_to_children = 4;
   */
  relationshipToChildren?: string;

  /**
   * @generated from field: guardianai.v1.familycare.ServiceAddress service_address = 5;
   */
  serviceAddress?: ServiceAddressJson;

  /**
   * @generated from field: repeated guardianai.v1.familycare.BookingChild children = 6;
   */
  children?: BookingChildJson[];

  /**
   * @generated from field: string emergency_contact_name = 7;
   */
  emergencyContactName?: string;

  /**
   * @generated from field: string emergency_contact_phone = 8;
   */
  emergencyContactPhone?: string;

  /**
   * @generated from field: string emergency_contact_relationship = 9;
   */
  emergencyContactRelationship?: string;

  /**
   * @generated from field: string parent_notes = 10;
   */
  parentNotes?: string;

  /**
   * @generated from field: string admin_notes = 11;
   */
  adminNotes?: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 12;
   */
  stripePaymentIntentId?: string;

  /**
   * @generated from field: int64 subtotal_cents = 13;
   */
  subtotalCents?: string;

  /**
   * @generated from field: int64 tax_cents = 14;
   */
  taxCents?: string;

  /**
   * @generated from field: guardianai.v1.familycare.AssignmentStatus assignment_status = 15;
   */
  assignmentStatus?: AssignmentStatusJson;

  /**
   * @generated from field: string assigned_worker_id = 16;
   */
  assignedWorkerId?: string;

  /**
   * @generated from field: int64 checked_in_at = 17;
   */
  checkedInAt?: string;

  /**
   * @generated from field: int64 checked_out_at = 18;
   */
  checkedOutAt?: string;

  /**
   * @generated from field: int32 actual_minutes = 19;
   */
  actualMinutes?: number;

  /**
   * @generated from field: int32 payable_minutes = 20;
   */
  payableMinutes?: number;

  /**
   * @generated from field: string care_summary = 21;
   */
  careSummary?: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.IncidentRecord incidents = 22;
   */
  incidents?: IncidentRecordJson[];

  /**
   * @generated from field: repeated guardianai.v1.familycare.ReceiptRecord receipts = 23;
   */
  receipts?: ReceiptRecordJson[];

  /**
   * @generated from field: guardianai.v1.familycare.KnownCaregiverRequest known_caregiver_request = 24;
   */
  knownCaregiverRequest?: KnownCaregiverRequestJson;

  /**
   * @generated from field: int64 client_offered_hourly_rate_cents = 25;
   */
  clientOfferedHourlyRateCents?: string;

  /**
   * @generated from field: string match_status_note = 26;
   */
  matchStatusNote?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AdminBookingDetail.
 * Use `create(AdminBookingDetailSchema)` to create a new message.
 */
export const AdminBookingDetailSchema: GenMessage<AdminBookingDetail, {jsonType: AdminBookingDetailJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 99);

/**
 * @generated from message guardianai.v1.familycare.WorkerDocument
 */
export type WorkerDocument = Message<"guardianai.v1.familycare.WorkerDocument"> & {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 2;
   */
  documentType: WorkerDocumentType;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 3;
   */
  status: WorkerDocumentStatus;

  /**
   * @generated from field: string issue_date = 4;
   */
  issueDate: string;

  /**
   * @generated from field: string expiry_date = 5;
   */
  expiryDate: string;

  /**
   * @generated from field: string original_filename = 6;
   */
  originalFilename: string;

  /**
   * @generated from field: bool required_for_assignment = 7;
   */
  requiredForAssignment: boolean;

  /**
   * @generated from field: int64 admin_verified_at = 8;
   */
  adminVerifiedAt: bigint;

  /**
   * @generated from field: int32 tax_year = 9;
   */
  taxYear: number;

  /**
   * @generated from field: int32 version = 10;
   */
  version: number;

  /**
   * @generated from field: int64 submitted_at = 11;
   */
  submittedAt: bigint;

  /**
   * @generated from field: int64 employee_certified_at = 12;
   */
  employeeCertifiedAt: bigint;

  /**
   * @generated from field: string retention_until = 13;
   */
  retentionUntil: string;

  /**
   * @generated from field: string file_sha256 = 14;
   */
  fileSha256: string;
};

/**
 * @generated from message guardianai.v1.familycare.WorkerDocument
 */
export type WorkerDocumentJson = {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 2;
   */
  documentType?: WorkerDocumentTypeJson;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 3;
   */
  status?: WorkerDocumentStatusJson;

  /**
   * @generated from field: string issue_date = 4;
   */
  issueDate?: string;

  /**
   * @generated from field: string expiry_date = 5;
   */
  expiryDate?: string;

  /**
   * @generated from field: string original_filename = 6;
   */
  originalFilename?: string;

  /**
   * @generated from field: bool required_for_assignment = 7;
   */
  requiredForAssignment?: boolean;

  /**
   * @generated from field: int64 admin_verified_at = 8;
   */
  adminVerifiedAt?: string;

  /**
   * @generated from field: int32 tax_year = 9;
   */
  taxYear?: number;

  /**
   * @generated from field: int32 version = 10;
   */
  version?: number;

  /**
   * @generated from field: int64 submitted_at = 11;
   */
  submittedAt?: string;

  /**
   * @generated from field: int64 employee_certified_at = 12;
   */
  employeeCertifiedAt?: string;

  /**
   * @generated from field: string retention_until = 13;
   */
  retentionUntil?: string;

  /**
   * @generated from field: string file_sha256 = 14;
   */
  fileSha256?: string;
};

/**
 * Describes the message guardianai.v1.familycare.WorkerDocument.
 * Use `create(WorkerDocumentSchema)` to create a new message.
 */
export const WorkerDocumentSchema: GenMessage<WorkerDocument, {jsonType: WorkerDocumentJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 100);

/**
 * @generated from message guardianai.v1.familycare.WorkerProfile
 */
export type WorkerProfile = Message<"guardianai.v1.familycare.WorkerProfile"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string email = 4;
   */
  email: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone: string;

  /**
   * @generated from field: string employee_code = 6;
   */
  employeeCode: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 7;
   */
  hourlyRateCents: bigint;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 8;
   */
  vacationPayBasisPoints: number;

  /**
   * @generated from field: string employment_type = 9;
   */
  employmentType: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status = 10;
   */
  status: WorkerStatus;

  /**
   * @generated from field: string hire_date = 11;
   */
  hireDate: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerDocument documents = 12;
   */
  documents: WorkerDocument[];

  /**
   * @generated from field: bool assignment_eligible = 13;
   */
  assignmentEligible: boolean;

  /**
   * @generated from field: repeated string assignment_blockers = 14;
   */
  assignmentBlockers: string[];

  /**
   * @generated from field: bool rate_eligible = 15;
   */
  rateEligible: boolean;

  /**
   * @generated from field: int64 assignment_rate_floor_cents = 16;
   */
  assignmentRateFloorCents: bigint;

  /**
   * @generated from field: int64 compared_booking_hourly_rate_cents = 17;
   */
  comparedBookingHourlyRateCents: bigint;

  /**
   * @generated from field: repeated string match_reasons = 18;
   */
  matchReasons: string[];
};

/**
 * @generated from message guardianai.v1.familycare.WorkerProfile
 */
export type WorkerProfileJson = {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string name = 3;
   */
  name?: string;

  /**
   * @generated from field: string email = 4;
   */
  email?: string;

  /**
   * @generated from field: string phone = 5;
   */
  phone?: string;

  /**
   * @generated from field: string employee_code = 6;
   */
  employeeCode?: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 7;
   */
  hourlyRateCents?: string;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 8;
   */
  vacationPayBasisPoints?: number;

  /**
   * @generated from field: string employment_type = 9;
   */
  employmentType?: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status = 10;
   */
  status?: WorkerStatusJson;

  /**
   * @generated from field: string hire_date = 11;
   */
  hireDate?: string;

  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerDocument documents = 12;
   */
  documents?: WorkerDocumentJson[];

  /**
   * @generated from field: bool assignment_eligible = 13;
   */
  assignmentEligible?: boolean;

  /**
   * @generated from field: repeated string assignment_blockers = 14;
   */
  assignmentBlockers?: string[];

  /**
   * @generated from field: bool rate_eligible = 15;
   */
  rateEligible?: boolean;

  /**
   * @generated from field: int64 assignment_rate_floor_cents = 16;
   */
  assignmentRateFloorCents?: string;

  /**
   * @generated from field: int64 compared_booking_hourly_rate_cents = 17;
   */
  comparedBookingHourlyRateCents?: string;

  /**
   * @generated from field: repeated string match_reasons = 18;
   */
  matchReasons?: string[];
};

/**
 * Describes the message guardianai.v1.familycare.WorkerProfile.
 * Use `create(WorkerProfileSchema)` to create a new message.
 */
export const WorkerProfileSchema: GenMessage<WorkerProfile, {jsonType: WorkerProfileJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 101);

/**
 * @generated from message guardianai.v1.familycare.ListWorkersRequest
 */
export type ListWorkersRequest = Message<"guardianai.v1.familycare.ListWorkersRequest"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status_filter = 1;
   */
  statusFilter: WorkerStatus;

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListWorkersRequest
 */
export type ListWorkersRequestJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status_filter = 1;
   */
  statusFilter?: WorkerStatusJson;

  /**
   * @generated from field: string search_query = 2;
   */
  searchQuery?: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListWorkersRequest.
 * Use `create(ListWorkersRequestSchema)` to create a new message.
 */
export const ListWorkersRequestSchema: GenMessage<ListWorkersRequest, {jsonType: ListWorkersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 102);

/**
 * @generated from message guardianai.v1.familycare.ListWorkersResponse
 */
export type ListWorkersResponse = Message<"guardianai.v1.familycare.ListWorkersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerProfile workers = 1;
   */
  workers: WorkerProfile[];
};

/**
 * @generated from message guardianai.v1.familycare.ListWorkersResponse
 */
export type ListWorkersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.WorkerProfile workers = 1;
   */
  workers?: WorkerProfileJson[];
};

/**
 * Describes the message guardianai.v1.familycare.ListWorkersResponse.
 * Use `create(ListWorkersResponseSchema)` to create a new message.
 */
export const ListWorkersResponseSchema: GenMessage<ListWorkersResponse, {jsonType: ListWorkersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 103);

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerRequest
 */
export type UpsertWorkerRequest = Message<"guardianai.v1.familycare.UpsertWorkerRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string phone = 3;
   */
  phone: string;

  /**
   * @generated from field: string employee_code = 4;
   */
  employeeCode: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 5;
   */
  hourlyRateCents: bigint;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 6;
   */
  vacationPayBasisPoints: number;

  /**
   * @generated from field: string employment_type = 7;
   */
  employmentType: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status = 8;
   */
  status: WorkerStatus;

  /**
   * @generated from field: string hire_date = 9;
   */
  hireDate: string;
};

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerRequest
 */
export type UpsertWorkerRequestJson = {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string phone = 3;
   */
  phone?: string;

  /**
   * @generated from field: string employee_code = 4;
   */
  employeeCode?: string;

  /**
   * @generated from field: int64 hourly_rate_cents = 5;
   */
  hourlyRateCents?: string;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 6;
   */
  vacationPayBasisPoints?: number;

  /**
   * @generated from field: string employment_type = 7;
   */
  employmentType?: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerStatus status = 8;
   */
  status?: WorkerStatusJson;

  /**
   * @generated from field: string hire_date = 9;
   */
  hireDate?: string;
};

/**
 * Describes the message guardianai.v1.familycare.UpsertWorkerRequest.
 * Use `create(UpsertWorkerRequestSchema)` to create a new message.
 */
export const UpsertWorkerRequestSchema: GenMessage<UpsertWorkerRequest, {jsonType: UpsertWorkerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 104);

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerResponse
 */
export type UpsertWorkerResponse = Message<"guardianai.v1.familycare.UpsertWorkerResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerProfile worker = 1;
   */
  worker?: WorkerProfile;
};

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerResponse
 */
export type UpsertWorkerResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerProfile worker = 1;
   */
  worker?: WorkerProfileJson;
};

/**
 * Describes the message guardianai.v1.familycare.UpsertWorkerResponse.
 * Use `create(UpsertWorkerResponseSchema)` to create a new message.
 */
export const UpsertWorkerResponseSchema: GenMessage<UpsertWorkerResponse, {jsonType: UpsertWorkerResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 105);

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerDocumentRequest
 */
export type UpsertWorkerDocumentRequest = Message<"guardianai.v1.familycare.UpsertWorkerDocumentRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 3;
   */
  documentType: WorkerDocumentType;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 4;
   */
  status: WorkerDocumentStatus;

  /**
   * @generated from field: string issue_date = 5;
   */
  issueDate: string;

  /**
   * @generated from field: string expiry_date = 6;
   */
  expiryDate: string;

  /**
   * @generated from field: string original_filename = 7;
   */
  originalFilename: string;

  /**
   * @generated from field: bytes file_data = 8;
   */
  fileData: Uint8Array;

  /**
   * @generated from field: string content_type = 9;
   */
  contentType: string;

  /**
   * @generated from field: bool required_for_assignment = 10;
   */
  requiredForAssignment: boolean;

  /**
   * @generated from field: int32 tax_year = 11;
   */
  taxYear: number;
};

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerDocumentRequest
 */
export type UpsertWorkerDocumentRequestJson = {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId?: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentType document_type = 3;
   */
  documentType?: WorkerDocumentTypeJson;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 4;
   */
  status?: WorkerDocumentStatusJson;

  /**
   * @generated from field: string issue_date = 5;
   */
  issueDate?: string;

  /**
   * @generated from field: string expiry_date = 6;
   */
  expiryDate?: string;

  /**
   * @generated from field: string original_filename = 7;
   */
  originalFilename?: string;

  /**
   * @generated from field: bytes file_data = 8;
   */
  fileData?: string;

  /**
   * @generated from field: string content_type = 9;
   */
  contentType?: string;

  /**
   * @generated from field: bool required_for_assignment = 10;
   */
  requiredForAssignment?: boolean;

  /**
   * @generated from field: int32 tax_year = 11;
   */
  taxYear?: number;
};

/**
 * Describes the message guardianai.v1.familycare.UpsertWorkerDocumentRequest.
 * Use `create(UpsertWorkerDocumentRequestSchema)` to create a new message.
 */
export const UpsertWorkerDocumentRequestSchema: GenMessage<UpsertWorkerDocumentRequest, {jsonType: UpsertWorkerDocumentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 106);

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerDocumentResponse
 */
export type UpsertWorkerDocumentResponse = Message<"guardianai.v1.familycare.UpsertWorkerDocumentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocument;
};

/**
 * @generated from message guardianai.v1.familycare.UpsertWorkerDocumentResponse
 */
export type UpsertWorkerDocumentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocumentJson;
};

/**
 * Describes the message guardianai.v1.familycare.UpsertWorkerDocumentResponse.
 * Use `create(UpsertWorkerDocumentResponseSchema)` to create a new message.
 */
export const UpsertWorkerDocumentResponseSchema: GenMessage<UpsertWorkerDocumentResponse, {jsonType: UpsertWorkerDocumentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 107);

/**
 * @generated from message guardianai.v1.familycare.ReviewWorkerDocumentRequest
 */
export type ReviewWorkerDocumentRequest = Message<"guardianai.v1.familycare.ReviewWorkerDocumentRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 3;
   */
  status: WorkerDocumentStatus;

  /**
   * @generated from field: string review_notes = 4;
   */
  reviewNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewWorkerDocumentRequest
 */
export type ReviewWorkerDocumentRequestJson = {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId?: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId?: string;

  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocumentStatus status = 3;
   */
  status?: WorkerDocumentStatusJson;

  /**
   * @generated from field: string review_notes = 4;
   */
  reviewNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewWorkerDocumentRequest.
 * Use `create(ReviewWorkerDocumentRequestSchema)` to create a new message.
 */
export const ReviewWorkerDocumentRequestSchema: GenMessage<ReviewWorkerDocumentRequest, {jsonType: ReviewWorkerDocumentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 108);

/**
 * @generated from message guardianai.v1.familycare.ReviewWorkerDocumentResponse
 */
export type ReviewWorkerDocumentResponse = Message<"guardianai.v1.familycare.ReviewWorkerDocumentResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocument;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewWorkerDocumentResponse
 */
export type ReviewWorkerDocumentResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.WorkerDocument document = 1;
   */
  document?: WorkerDocumentJson;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewWorkerDocumentResponse.
 * Use `create(ReviewWorkerDocumentResponseSchema)` to create a new message.
 */
export const ReviewWorkerDocumentResponseSchema: GenMessage<ReviewWorkerDocumentResponse, {jsonType: ReviewWorkerDocumentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 109);

/**
 * @generated from message guardianai.v1.familycare.DownloadWorkerDocumentRequest
 */
export type DownloadWorkerDocumentRequest = Message<"guardianai.v1.familycare.DownloadWorkerDocumentRequest"> & {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId: string;

  /**
   * @generated from field: string access_reason = 3;
   */
  accessReason: string;
};

/**
 * @generated from message guardianai.v1.familycare.DownloadWorkerDocumentRequest
 */
export type DownloadWorkerDocumentRequestJson = {
  /**
   * @generated from field: string worker_id = 1;
   */
  workerId?: string;

  /**
   * @generated from field: string document_id = 2;
   */
  documentId?: string;

  /**
   * @generated from field: string access_reason = 3;
   */
  accessReason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.DownloadWorkerDocumentRequest.
 * Use `create(DownloadWorkerDocumentRequestSchema)` to create a new message.
 */
export const DownloadWorkerDocumentRequestSchema: GenMessage<DownloadWorkerDocumentRequest, {jsonType: DownloadWorkerDocumentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 110);

/**
 * @generated from message guardianai.v1.familycare.DownloadWorkerDocumentResponse
 */
export type DownloadWorkerDocumentResponse = Message<"guardianai.v1.familycare.DownloadWorkerDocumentResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;

  /**
   * @generated from field: string file_sha256 = 4;
   */
  fileSha256: string;
};

/**
 * @generated from message guardianai.v1.familycare.DownloadWorkerDocumentResponse
 */
export type DownloadWorkerDocumentResponseJson = {
  /**
   * @generated from field: bytes data = 1;
   */
  data?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;

  /**
   * @generated from field: string file_sha256 = 4;
   */
  fileSha256?: string;
};

/**
 * Describes the message guardianai.v1.familycare.DownloadWorkerDocumentResponse.
 * Use `create(DownloadWorkerDocumentResponseSchema)` to create a new message.
 */
export const DownloadWorkerDocumentResponseSchema: GenMessage<DownloadWorkerDocumentResponse, {jsonType: DownloadWorkerDocumentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 111);

/**
 * @generated from message guardianai.v1.familycare.AssignWorkerRequest
 */
export type AssignWorkerRequest = Message<"guardianai.v1.familycare.AssignWorkerRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId: string;

  /**
   * @generated from field: bool override_credential_block = 3;
   */
  overrideCredentialBlock: boolean;

  /**
   * @generated from field: string override_reason = 4;
   */
  overrideReason: string;

  /**
   * @generated from field: string admin_notes = 5;
   */
  adminNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.AssignWorkerRequest
 */
export type AssignWorkerRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string worker_id = 2;
   */
  workerId?: string;

  /**
   * @generated from field: bool override_credential_block = 3;
   */
  overrideCredentialBlock?: boolean;

  /**
   * @generated from field: string override_reason = 4;
   */
  overrideReason?: string;

  /**
   * @generated from field: string admin_notes = 5;
   */
  adminNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AssignWorkerRequest.
 * Use `create(AssignWorkerRequestSchema)` to create a new message.
 */
export const AssignWorkerRequestSchema: GenMessage<AssignWorkerRequest, {jsonType: AssignWorkerRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 112);

/**
 * @generated from message guardianai.v1.familycare.AssignWorkerResponse
 */
export type AssignWorkerResponse = Message<"guardianai.v1.familycare.AssignWorkerResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.AssignWorkerResponse
 */
export type AssignWorkerResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.AssignWorkerResponse.
 * Use `create(AssignWorkerResponseSchema)` to create a new message.
 */
export const AssignWorkerResponseSchema: GenMessage<AssignWorkerResponse, {jsonType: AssignWorkerResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 113);

/**
 * @generated from message guardianai.v1.familycare.CancelBookingRequest
 */
export type CancelBookingRequest = Message<"guardianai.v1.familycare.CancelBookingRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.familycare.CancelBookingRequest
 */
export type CancelBookingRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.CancelBookingRequest.
 * Use `create(CancelBookingRequestSchema)` to create a new message.
 */
export const CancelBookingRequestSchema: GenMessage<CancelBookingRequest, {jsonType: CancelBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 114);

/**
 * @generated from message guardianai.v1.familycare.CancelBookingResponse
 */
export type CancelBookingResponse = Message<"guardianai.v1.familycare.CancelBookingResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.CancelBookingResponse
 */
export type CancelBookingResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.CancelBookingResponse.
 * Use `create(CancelBookingResponseSchema)` to create a new message.
 */
export const CancelBookingResponseSchema: GenMessage<CancelBookingResponse, {jsonType: CancelBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 115);

/**
 * @generated from message guardianai.v1.familycare.RequestRefundRequest
 */
export type RequestRefundRequest = Message<"guardianai.v1.familycare.RequestRefundRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.familycare.RequestRefundRequest
 */
export type RequestRefundRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.RequestRefundRequest.
 * Use `create(RequestRefundRequestSchema)` to create a new message.
 */
export const RequestRefundRequestSchema: GenMessage<RequestRefundRequest, {jsonType: RequestRefundRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 116);

/**
 * @generated from message guardianai.v1.familycare.RequestRefundResponse
 */
export type RequestRefundResponse = Message<"guardianai.v1.familycare.RequestRefundResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.RequestRefundResponse
 */
export type RequestRefundResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.RequestRefundResponse.
 * Use `create(RequestRefundResponseSchema)` to create a new message.
 */
export const RequestRefundResponseSchema: GenMessage<RequestRefundResponse, {jsonType: RequestRefundResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 117);

/**
 * @generated from message guardianai.v1.familycare.ReviewCompletedVisitRequest
 */
export type ReviewCompletedVisitRequest = Message<"guardianai.v1.familycare.ReviewCompletedVisitRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: bool approve_for_payroll = 2;
   */
  approveForPayroll: boolean;

  /**
   * @generated from field: string review_notes = 3;
   */
  reviewNotes: string;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewCompletedVisitRequest
 */
export type ReviewCompletedVisitRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: bool approve_for_payroll = 2;
   */
  approveForPayroll?: boolean;

  /**
   * @generated from field: string review_notes = 3;
   */
  reviewNotes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewCompletedVisitRequest.
 * Use `create(ReviewCompletedVisitRequestSchema)` to create a new message.
 */
export const ReviewCompletedVisitRequestSchema: GenMessage<ReviewCompletedVisitRequest, {jsonType: ReviewCompletedVisitRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 118);

/**
 * @generated from message guardianai.v1.familycare.ReviewCompletedVisitResponse
 */
export type ReviewCompletedVisitResponse = Message<"guardianai.v1.familycare.ReviewCompletedVisitResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.ReviewCompletedVisitResponse
 */
export type ReviewCompletedVisitResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.ReviewCompletedVisitResponse.
 * Use `create(ReviewCompletedVisitResponseSchema)` to create a new message.
 */
export const ReviewCompletedVisitResponseSchema: GenMessage<ReviewCompletedVisitResponse, {jsonType: ReviewCompletedVisitResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 119);

/**
 * @generated from message guardianai.v1.familycare.ReceiptRecord
 */
export type ReceiptRecord = Message<"guardianai.v1.familycare.ReceiptRecord"> & {
  /**
   * @generated from field: string receipt_id = 1;
   */
  receiptId: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: string receipt_number = 3;
   */
  receiptNumber: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: guardianai.v1.familycare.ReceiptStatus status = 5;
   */
  status: ReceiptStatus;

  /**
   * @generated from field: int64 issued_at = 6;
   */
  issuedAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.ReceiptRecord
 */
export type ReceiptRecordJson = {
  /**
   * @generated from field: string receipt_id = 1;
   */
  receiptId?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: string receipt_number = 3;
   */
  receiptNumber?: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version?: number;

  /**
   * @generated from field: guardianai.v1.familycare.ReceiptStatus status = 5;
   */
  status?: ReceiptStatusJson;

  /**
   * @generated from field: int64 issued_at = 6;
   */
  issuedAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ReceiptRecord.
 * Use `create(ReceiptRecordSchema)` to create a new message.
 */
export const ReceiptRecordSchema: GenMessage<ReceiptRecord, {jsonType: ReceiptRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 120);

/**
 * @generated from message guardianai.v1.familycare.GenerateReceiptRequest
 */
export type GenerateReceiptRequest = Message<"guardianai.v1.familycare.GenerateReceiptRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string issuer_statement = 2;
   */
  issuerStatement: string;
};

/**
 * @generated from message guardianai.v1.familycare.GenerateReceiptRequest
 */
export type GenerateReceiptRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string issuer_statement = 2;
   */
  issuerStatement?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GenerateReceiptRequest.
 * Use `create(GenerateReceiptRequestSchema)` to create a new message.
 */
export const GenerateReceiptRequestSchema: GenMessage<GenerateReceiptRequest, {jsonType: GenerateReceiptRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 121);

/**
 * @generated from message guardianai.v1.familycare.GenerateReceiptResponse
 */
export type GenerateReceiptResponse = Message<"guardianai.v1.familycare.GenerateReceiptResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.ReceiptRecord receipt = 1;
   */
  receipt?: ReceiptRecord;
};

/**
 * @generated from message guardianai.v1.familycare.GenerateReceiptResponse
 */
export type GenerateReceiptResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.ReceiptRecord receipt = 1;
   */
  receipt?: ReceiptRecordJson;
};

/**
 * Describes the message guardianai.v1.familycare.GenerateReceiptResponse.
 * Use `create(GenerateReceiptResponseSchema)` to create a new message.
 */
export const GenerateReceiptResponseSchema: GenMessage<GenerateReceiptResponse, {jsonType: GenerateReceiptResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 122);

/**
 * @generated from message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptRequest
 */
export type AdminFamilyCareServiceDownloadReceiptRequest = Message<"guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId: string;
};

/**
 * @generated from message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptRequest
 */
export type AdminFamilyCareServiceDownloadReceiptRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string receipt_id = 2;
   */
  receiptId?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptRequest.
 * Use `create(AdminFamilyCareServiceDownloadReceiptRequestSchema)` to create a new message.
 */
export const AdminFamilyCareServiceDownloadReceiptRequestSchema: GenMessage<AdminFamilyCareServiceDownloadReceiptRequest, {jsonType: AdminFamilyCareServiceDownloadReceiptRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 123);

/**
 * @generated from message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptResponse
 */
export type AdminFamilyCareServiceDownloadReceiptResponse = Message<"guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptResponse"> & {
  /**
   * @generated from field: bytes data = 1;
   */
  data: Uint8Array;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * @generated from message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptResponse
 */
export type AdminFamilyCareServiceDownloadReceiptResponseJson = {
  /**
   * @generated from field: bytes data = 1;
   */
  data?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * @generated from field: string filename = 3;
   */
  filename?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AdminFamilyCareServiceDownloadReceiptResponse.
 * Use `create(AdminFamilyCareServiceDownloadReceiptResponseSchema)` to create a new message.
 */
export const AdminFamilyCareServiceDownloadReceiptResponseSchema: GenMessage<AdminFamilyCareServiceDownloadReceiptResponse, {jsonType: AdminFamilyCareServiceDownloadReceiptResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 124);

/**
 * @generated from message guardianai.v1.familycare.GetSettingsRequest
 */
export type GetSettingsRequest = Message<"guardianai.v1.familycare.GetSettingsRequest"> & {
};

/**
 * @generated from message guardianai.v1.familycare.GetSettingsRequest
 */
export type GetSettingsRequestJson = {
};

/**
 * Describes the message guardianai.v1.familycare.GetSettingsRequest.
 * Use `create(GetSettingsRequestSchema)` to create a new message.
 */
export const GetSettingsRequestSchema: GenMessage<GetSettingsRequest, {jsonType: GetSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 125);

/**
 * @generated from message guardianai.v1.familycare.FamilyCareSettings
 */
export type FamilyCareSettings = Message<"guardianai.v1.familycare.FamilyCareSettings"> & {
  /**
   * @generated from field: bool service_enabled = 1;
   */
  serviceEnabled: boolean;

  /**
   * @generated from field: int32 minimum_booking_minutes = 2;
   */
  minimumBookingMinutes: number;

  /**
   * @generated from field: int32 booking_increment_minutes = 3;
   */
  bookingIncrementMinutes: number;

  /**
   * @generated from field: int64 client_hourly_rate_cents = 4;
   */
  clientHourlyRateCents: bigint;

  /**
   * @generated from field: int64 default_worker_hourly_wage_cents = 5;
   */
  defaultWorkerHourlyWageCents: bigint;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 6;
   */
  vacationPayBasisPoints: number;

  /**
   * @generated from field: int32 cancellation_window_hours = 7;
   */
  cancellationWindowHours: number;

  /**
   * @generated from field: string refund_policy = 8;
   */
  refundPolicy: string;

  /**
   * @generated from field: repeated string service_areas = 9;
   */
  serviceAreas: string[];

  /**
   * @generated from field: guardianai.v1.familycare.TaxMode tax_mode = 10;
   */
  taxMode: TaxMode;

  /**
   * @generated from field: int32 tax_rate_basis_points = 11;
   */
  taxRateBasisPoints: number;

  /**
   * @generated from field: string stripe_mode = 12;
   */
  stripeMode: string;

  /**
   * @generated from field: string receipt_issuer_name = 13;
   */
  receiptIssuerName: string;

  /**
   * @generated from field: string receipt_issuer_address = 14;
   */
  receiptIssuerAddress: string;

  /**
   * @generated from field: string support_email = 15;
   */
  supportEmail: string;

  /**
   * @generated from field: string support_phone = 16;
   */
  supportPhone: string;

  /**
   * @generated from field: string terms_version = 17;
   */
  termsVersion: string;

  /**
   * @generated from field: string privacy_notice_version = 18;
   */
  privacyNoticeVersion: string;

  /**
   * @generated from field: string cancellation_policy_text = 19;
   */
  cancellationPolicyText: string;

  /**
   * @generated from field: int64 updated_at = 20;
   */
  updatedAt: bigint;

  /**
   * @generated from field: int64 minimum_client_hourly_rate_cents = 21;
   */
  minimumClientHourlyRateCents: bigint;

  /**
   * @generated from field: int32 assignment_margin_basis_points = 22;
   */
  assignmentMarginBasisPoints: number;

  /**
   * @generated from field: int64 assignment_margin_cents = 23;
   */
  assignmentMarginCents: bigint;

  /**
   * @generated from field: string rate_guidance_text = 24;
   */
  rateGuidanceText: string;
};

/**
 * @generated from message guardianai.v1.familycare.FamilyCareSettings
 */
export type FamilyCareSettingsJson = {
  /**
   * @generated from field: bool service_enabled = 1;
   */
  serviceEnabled?: boolean;

  /**
   * @generated from field: int32 minimum_booking_minutes = 2;
   */
  minimumBookingMinutes?: number;

  /**
   * @generated from field: int32 booking_increment_minutes = 3;
   */
  bookingIncrementMinutes?: number;

  /**
   * @generated from field: int64 client_hourly_rate_cents = 4;
   */
  clientHourlyRateCents?: string;

  /**
   * @generated from field: int64 default_worker_hourly_wage_cents = 5;
   */
  defaultWorkerHourlyWageCents?: string;

  /**
   * @generated from field: int32 vacation_pay_basis_points = 6;
   */
  vacationPayBasisPoints?: number;

  /**
   * @generated from field: int32 cancellation_window_hours = 7;
   */
  cancellationWindowHours?: number;

  /**
   * @generated from field: string refund_policy = 8;
   */
  refundPolicy?: string;

  /**
   * @generated from field: repeated string service_areas = 9;
   */
  serviceAreas?: string[];

  /**
   * @generated from field: guardianai.v1.familycare.TaxMode tax_mode = 10;
   */
  taxMode?: TaxModeJson;

  /**
   * @generated from field: int32 tax_rate_basis_points = 11;
   */
  taxRateBasisPoints?: number;

  /**
   * @generated from field: string stripe_mode = 12;
   */
  stripeMode?: string;

  /**
   * @generated from field: string receipt_issuer_name = 13;
   */
  receiptIssuerName?: string;

  /**
   * @generated from field: string receipt_issuer_address = 14;
   */
  receiptIssuerAddress?: string;

  /**
   * @generated from field: string support_email = 15;
   */
  supportEmail?: string;

  /**
   * @generated from field: string support_phone = 16;
   */
  supportPhone?: string;

  /**
   * @generated from field: string terms_version = 17;
   */
  termsVersion?: string;

  /**
   * @generated from field: string privacy_notice_version = 18;
   */
  privacyNoticeVersion?: string;

  /**
   * @generated from field: string cancellation_policy_text = 19;
   */
  cancellationPolicyText?: string;

  /**
   * @generated from field: int64 updated_at = 20;
   */
  updatedAt?: string;

  /**
   * @generated from field: int64 minimum_client_hourly_rate_cents = 21;
   */
  minimumClientHourlyRateCents?: string;

  /**
   * @generated from field: int32 assignment_margin_basis_points = 22;
   */
  assignmentMarginBasisPoints?: number;

  /**
   * @generated from field: int64 assignment_margin_cents = 23;
   */
  assignmentMarginCents?: string;

  /**
   * @generated from field: string rate_guidance_text = 24;
   */
  rateGuidanceText?: string;
};

/**
 * Describes the message guardianai.v1.familycare.FamilyCareSettings.
 * Use `create(FamilyCareSettingsSchema)` to create a new message.
 */
export const FamilyCareSettingsSchema: GenMessage<FamilyCareSettings, {jsonType: FamilyCareSettingsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 126);

/**
 * @generated from message guardianai.v1.familycare.UpdateSettingsRequest
 */
export type UpdateSettingsRequest = Message<"guardianai.v1.familycare.UpdateSettingsRequest"> & {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettings;
};

/**
 * @generated from message guardianai.v1.familycare.UpdateSettingsRequest
 */
export type UpdateSettingsRequestJson = {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettingsJson;
};

/**
 * Describes the message guardianai.v1.familycare.UpdateSettingsRequest.
 * Use `create(UpdateSettingsRequestSchema)` to create a new message.
 */
export const UpdateSettingsRequestSchema: GenMessage<UpdateSettingsRequest, {jsonType: UpdateSettingsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 127);

/**
 * @generated from message guardianai.v1.familycare.GetSettingsResponse
 */
export type GetSettingsResponse = Message<"guardianai.v1.familycare.GetSettingsResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettings;
};

/**
 * @generated from message guardianai.v1.familycare.GetSettingsResponse
 */
export type GetSettingsResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettingsJson;
};

/**
 * Describes the message guardianai.v1.familycare.GetSettingsResponse.
 * Use `create(GetSettingsResponseSchema)` to create a new message.
 */
export const GetSettingsResponseSchema: GenMessage<GetSettingsResponse, {jsonType: GetSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 128);

/**
 * @generated from message guardianai.v1.familycare.UpdateSettingsResponse
 */
export type UpdateSettingsResponse = Message<"guardianai.v1.familycare.UpdateSettingsResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettings;
};

/**
 * @generated from message guardianai.v1.familycare.UpdateSettingsResponse
 */
export type UpdateSettingsResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.FamilyCareSettings settings = 1;
   */
  settings?: FamilyCareSettingsJson;
};

/**
 * Describes the message guardianai.v1.familycare.UpdateSettingsResponse.
 * Use `create(UpdateSettingsResponseSchema)` to create a new message.
 */
export const UpdateSettingsResponseSchema: GenMessage<UpdateSettingsResponse, {jsonType: UpdateSettingsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 129);

/**
 * @generated from message guardianai.v1.familycare.GeneratePayrollExportRequest
 */
export type GeneratePayrollExportRequest = Message<"guardianai.v1.familycare.GeneratePayrollExportRequest"> & {
  /**
   * @generated from field: string payroll_period_start = 1;
   */
  payrollPeriodStart: string;

  /**
   * @generated from field: string payroll_period_end = 2;
   */
  payrollPeriodEnd: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.familycare.GeneratePayrollExportRequest
 */
export type GeneratePayrollExportRequestJson = {
  /**
   * @generated from field: string payroll_period_start = 1;
   */
  payrollPeriodStart?: string;

  /**
   * @generated from field: string payroll_period_end = 2;
   */
  payrollPeriodEnd?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GeneratePayrollExportRequest.
 * Use `create(GeneratePayrollExportRequestSchema)` to create a new message.
 */
export const GeneratePayrollExportRequestSchema: GenMessage<GeneratePayrollExportRequest, {jsonType: GeneratePayrollExportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 130);

/**
 * @generated from message guardianai.v1.familycare.PayrollExportLine
 */
export type PayrollExportLine = Message<"guardianai.v1.familycare.PayrollExportLine"> & {
  /**
   * @generated from field: string employee_name = 1;
   */
  employeeName: string;

  /**
   * @generated from field: string employee_code = 2;
   */
  employeeCode: string;

  /**
   * @generated from field: string booking_number = 3;
   */
  bookingNumber: string;

  /**
   * @generated from field: string work_date = 4;
   */
  workDate: string;

  /**
   * @generated from field: string client_reference = 5;
   */
  clientReference: string;

  /**
   * @generated from field: string start_time = 6;
   */
  startTime: string;

  /**
   * @generated from field: string end_time = 7;
   */
  endTime: string;

  /**
   * @generated from field: int32 actual_minutes = 8;
   */
  actualMinutes: number;

  /**
   * @generated from field: int32 payable_minutes = 9;
   */
  payableMinutes: number;

  /**
   * @generated from field: int64 hourly_rate_cents = 10;
   */
  hourlyRateCents: bigint;

  /**
   * @generated from field: int64 gross_wages_cents = 11;
   */
  grossWagesCents: bigint;

  /**
   * @generated from field: int64 vacation_pay_cents = 12;
   */
  vacationPayCents: bigint;

  /**
   * @generated from field: int64 total_gross_before_deductions_cents = 13;
   */
  totalGrossBeforeDeductionsCents: bigint;

  /**
   * @generated from field: string notes = 14;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.familycare.PayrollExportLine
 */
export type PayrollExportLineJson = {
  /**
   * @generated from field: string employee_name = 1;
   */
  employeeName?: string;

  /**
   * @generated from field: string employee_code = 2;
   */
  employeeCode?: string;

  /**
   * @generated from field: string booking_number = 3;
   */
  bookingNumber?: string;

  /**
   * @generated from field: string work_date = 4;
   */
  workDate?: string;

  /**
   * @generated from field: string client_reference = 5;
   */
  clientReference?: string;

  /**
   * @generated from field: string start_time = 6;
   */
  startTime?: string;

  /**
   * @generated from field: string end_time = 7;
   */
  endTime?: string;

  /**
   * @generated from field: int32 actual_minutes = 8;
   */
  actualMinutes?: number;

  /**
   * @generated from field: int32 payable_minutes = 9;
   */
  payableMinutes?: number;

  /**
   * @generated from field: int64 hourly_rate_cents = 10;
   */
  hourlyRateCents?: string;

  /**
   * @generated from field: int64 gross_wages_cents = 11;
   */
  grossWagesCents?: string;

  /**
   * @generated from field: int64 vacation_pay_cents = 12;
   */
  vacationPayCents?: string;

  /**
   * @generated from field: int64 total_gross_before_deductions_cents = 13;
   */
  totalGrossBeforeDeductionsCents?: string;

  /**
   * @generated from field: string notes = 14;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.familycare.PayrollExportLine.
 * Use `create(PayrollExportLineSchema)` to create a new message.
 */
export const PayrollExportLineSchema: GenMessage<PayrollExportLine, {jsonType: PayrollExportLineJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 131);

/**
 * @generated from message guardianai.v1.familycare.GeneratePayrollExportResponse
 */
export type GeneratePayrollExportResponse = Message<"guardianai.v1.familycare.GeneratePayrollExportResponse"> & {
  /**
   * @generated from field: string payroll_export_id = 1;
   */
  payrollExportId: string;

  /**
   * @generated from field: string payroll_period_start = 2;
   */
  payrollPeriodStart: string;

  /**
   * @generated from field: string payroll_period_end = 3;
   */
  payrollPeriodEnd: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version: number;

  /**
   * @generated from field: repeated guardianai.v1.familycare.PayrollExportLine lines = 5;
   */
  lines: PayrollExportLine[];

  /**
   * @generated from field: bytes csv_data = 6;
   */
  csvData: Uint8Array;

  /**
   * @generated from field: string filename = 7;
   */
  filename: string;

  /**
   * @generated from field: int64 generated_at = 8;
   */
  generatedAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.GeneratePayrollExportResponse
 */
export type GeneratePayrollExportResponseJson = {
  /**
   * @generated from field: string payroll_export_id = 1;
   */
  payrollExportId?: string;

  /**
   * @generated from field: string payroll_period_start = 2;
   */
  payrollPeriodStart?: string;

  /**
   * @generated from field: string payroll_period_end = 3;
   */
  payrollPeriodEnd?: string;

  /**
   * @generated from field: int32 version = 4;
   */
  version?: number;

  /**
   * @generated from field: repeated guardianai.v1.familycare.PayrollExportLine lines = 5;
   */
  lines?: PayrollExportLineJson[];

  /**
   * @generated from field: bytes csv_data = 6;
   */
  csvData?: string;

  /**
   * @generated from field: string filename = 7;
   */
  filename?: string;

  /**
   * @generated from field: int64 generated_at = 8;
   */
  generatedAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.GeneratePayrollExportResponse.
 * Use `create(GeneratePayrollExportResponseSchema)` to create a new message.
 */
export const GeneratePayrollExportResponseSchema: GenMessage<GeneratePayrollExportResponse, {jsonType: GeneratePayrollExportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 132);

/**
 * @generated from message guardianai.v1.familycare.ReopenPayrollBookingRequest
 */
export type ReopenPayrollBookingRequest = Message<"guardianai.v1.familycare.ReopenPayrollBookingRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.familycare.ReopenPayrollBookingRequest
 */
export type ReopenPayrollBookingRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ReopenPayrollBookingRequest.
 * Use `create(ReopenPayrollBookingRequestSchema)` to create a new message.
 */
export const ReopenPayrollBookingRequestSchema: GenMessage<ReopenPayrollBookingRequest, {jsonType: ReopenPayrollBookingRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 133);

/**
 * @generated from message guardianai.v1.familycare.ReopenPayrollBookingResponse
 */
export type ReopenPayrollBookingResponse = Message<"guardianai.v1.familycare.ReopenPayrollBookingResponse"> & {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetail;
};

/**
 * @generated from message guardianai.v1.familycare.ReopenPayrollBookingResponse
 */
export type ReopenPayrollBookingResponseJson = {
  /**
   * @generated from field: guardianai.v1.familycare.AdminBookingDetail booking = 1;
   */
  booking?: AdminBookingDetailJson;
};

/**
 * Describes the message guardianai.v1.familycare.ReopenPayrollBookingResponse.
 * Use `create(ReopenPayrollBookingResponseSchema)` to create a new message.
 */
export const ReopenPayrollBookingResponseSchema: GenMessage<ReopenPayrollBookingResponse, {jsonType: ReopenPayrollBookingResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 134);

/**
 * @generated from message guardianai.v1.familycare.AuditLogRecord
 */
export type AuditLogRecord = Message<"guardianai.v1.familycare.AuditLogRecord"> & {
  /**
   * @generated from field: string audit_log_id = 1;
   */
  auditLogId: string;

  /**
   * @generated from field: string actor_user_id = 2;
   */
  actorUserId: string;

  /**
   * @generated from field: string actor_role = 3;
   */
  actorRole: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: string entity_type = 5;
   */
  entityType: string;

  /**
   * @generated from field: string entity_id = 6;
   */
  entityId: string;

  /**
   * @generated from field: string before_json = 7;
   */
  beforeJson: string;

  /**
   * @generated from field: string after_json = 8;
   */
  afterJson: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.familycare.AuditLogRecord
 */
export type AuditLogRecordJson = {
  /**
   * @generated from field: string audit_log_id = 1;
   */
  auditLogId?: string;

  /**
   * @generated from field: string actor_user_id = 2;
   */
  actorUserId?: string;

  /**
   * @generated from field: string actor_role = 3;
   */
  actorRole?: string;

  /**
   * @generated from field: string action = 4;
   */
  action?: string;

  /**
   * @generated from field: string entity_type = 5;
   */
  entityType?: string;

  /**
   * @generated from field: string entity_id = 6;
   */
  entityId?: string;

  /**
   * @generated from field: string before_json = 7;
   */
  beforeJson?: string;

  /**
   * @generated from field: string after_json = 8;
   */
  afterJson?: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.familycare.AuditLogRecord.
 * Use `create(AuditLogRecordSchema)` to create a new message.
 */
export const AuditLogRecordSchema: GenMessage<AuditLogRecord, {jsonType: AuditLogRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 135);

/**
 * @generated from message guardianai.v1.familycare.ListAuditLogsRequest
 */
export type ListAuditLogsRequest = Message<"guardianai.v1.familycare.ListAuditLogsRequest"> & {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId: string;

  /**
   * @generated from field: string action_filter = 2;
   */
  actionFilter: string;

  /**
   * @generated from field: int64 created_after = 3;
   */
  createdAfter: bigint;

  /**
   * @generated from field: int64 created_before = 4;
   */
  createdBefore: bigint;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListAuditLogsRequest
 */
export type ListAuditLogsRequestJson = {
  /**
   * @generated from field: string booking_id = 1;
   */
  bookingId?: string;

  /**
   * @generated from field: string action_filter = 2;
   */
  actionFilter?: string;

  /**
   * @generated from field: int64 created_after = 3;
   */
  createdAfter?: string;

  /**
   * @generated from field: int64 created_before = 4;
   */
  createdBefore?: string;

  /**
   * @generated from field: int32 page_size = 5;
   */
  pageSize?: number;

  /**
   * @generated from field: string page_token = 6;
   */
  pageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListAuditLogsRequest.
 * Use `create(ListAuditLogsRequestSchema)` to create a new message.
 */
export const ListAuditLogsRequestSchema: GenMessage<ListAuditLogsRequest, {jsonType: ListAuditLogsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 136);

/**
 * @generated from message guardianai.v1.familycare.ListAuditLogsResponse
 */
export type ListAuditLogsResponse = Message<"guardianai.v1.familycare.ListAuditLogsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.familycare.AuditLogRecord logs = 1;
   */
  logs: AuditLogRecord[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * @generated from message guardianai.v1.familycare.ListAuditLogsResponse
 */
export type ListAuditLogsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.familycare.AuditLogRecord logs = 1;
   */
  logs?: AuditLogRecordJson[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken?: string;
};

/**
 * Describes the message guardianai.v1.familycare.ListAuditLogsResponse.
 * Use `create(ListAuditLogsResponseSchema)` to create a new message.
 */
export const ListAuditLogsResponseSchema: GenMessage<ListAuditLogsResponse, {jsonType: ListAuditLogsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_familycare_family_care, 137);

/**
 * @generated from enum guardianai.v1.familycare.BookingStatus
 */
export enum BookingStatus {
  /**
   * @generated from enum value: BOOKING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: BOOKING_STATUS_PENDING_PAYMENT = 2;
   */
  PENDING_PAYMENT = 2,

  /**
   * @generated from enum value: BOOKING_STATUS_PAID_PENDING_ASSIGNMENT = 3;
   */
  PAID_PENDING_ASSIGNMENT = 3,

  /**
   * @generated from enum value: BOOKING_STATUS_ASSIGNED = 4;
   */
  ASSIGNED = 4,

  /**
   * @generated from enum value: BOOKING_STATUS_IN_PROGRESS = 5;
   */
  IN_PROGRESS = 5,

  /**
   * @generated from enum value: BOOKING_STATUS_COMPLETED_PENDING_REVIEW = 6;
   */
  COMPLETED_PENDING_REVIEW = 6,

  /**
   * @generated from enum value: BOOKING_STATUS_COMPLETED = 7;
   */
  COMPLETED = 7,

  /**
   * @generated from enum value: BOOKING_STATUS_CANCELLED = 8;
   */
  CANCELLED = 8,

  /**
   * @generated from enum value: BOOKING_STATUS_REFUNDED = 9;
   */
  REFUNDED = 9,

  /**
   * @generated from enum value: BOOKING_STATUS_PAYROLL_EXPORTED = 10;
   */
  PAYROLL_EXPORTED = 10,
}

/**
 * @generated from enum guardianai.v1.familycare.BookingStatus
 */
export type BookingStatusJson = "BOOKING_STATUS_UNSPECIFIED" | "BOOKING_STATUS_DRAFT" | "BOOKING_STATUS_PENDING_PAYMENT" | "BOOKING_STATUS_PAID_PENDING_ASSIGNMENT" | "BOOKING_STATUS_ASSIGNED" | "BOOKING_STATUS_IN_PROGRESS" | "BOOKING_STATUS_COMPLETED_PENDING_REVIEW" | "BOOKING_STATUS_COMPLETED" | "BOOKING_STATUS_CANCELLED" | "BOOKING_STATUS_REFUNDED" | "BOOKING_STATUS_PAYROLL_EXPORTED";

/**
 * Describes the enum guardianai.v1.familycare.BookingStatus.
 */
export const BookingStatusSchema: GenEnum<BookingStatus, BookingStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 0);

/**
 * @generated from enum guardianai.v1.familycare.PaymentStatus
 */
export enum PaymentStatus {
  /**
   * @generated from enum value: PAYMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: PAYMENT_STATUS_SUCCEEDED = 2;
   */
  SUCCEEDED = 2,

  /**
   * @generated from enum value: PAYMENT_STATUS_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: PAYMENT_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,

  /**
   * @generated from enum value: PAYMENT_STATUS_PARTIALLY_REFUNDED = 5;
   */
  PARTIALLY_REFUNDED = 5,

  /**
   * @generated from enum value: PAYMENT_STATUS_REFUNDED = 6;
   */
  REFUNDED = 6,
}

/**
 * @generated from enum guardianai.v1.familycare.PaymentStatus
 */
export type PaymentStatusJson = "PAYMENT_STATUS_UNSPECIFIED" | "PAYMENT_STATUS_PENDING" | "PAYMENT_STATUS_SUCCEEDED" | "PAYMENT_STATUS_FAILED" | "PAYMENT_STATUS_CANCELLED" | "PAYMENT_STATUS_PARTIALLY_REFUNDED" | "PAYMENT_STATUS_REFUNDED";

/**
 * Describes the enum guardianai.v1.familycare.PaymentStatus.
 */
export const PaymentStatusSchema: GenEnum<PaymentStatus, PaymentStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 1);

/**
 * @generated from enum guardianai.v1.familycare.AssignmentStatus
 */
export enum AssignmentStatus {
  /**
   * @generated from enum value: ASSIGNMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_OFFERED = 1;
   */
  OFFERED = 1,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_ACCEPTED = 2;
   */
  ACCEPTED = 2,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_DECLINED = 3;
   */
  DECLINED = 3,

  /**
   * @generated from enum value: ASSIGNMENT_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,
}

/**
 * @generated from enum guardianai.v1.familycare.AssignmentStatus
 */
export type AssignmentStatusJson = "ASSIGNMENT_STATUS_UNSPECIFIED" | "ASSIGNMENT_STATUS_OFFERED" | "ASSIGNMENT_STATUS_ACCEPTED" | "ASSIGNMENT_STATUS_DECLINED" | "ASSIGNMENT_STATUS_CANCELLED";

/**
 * Describes the enum guardianai.v1.familycare.AssignmentStatus.
 */
export const AssignmentStatusSchema: GenEnum<AssignmentStatus, AssignmentStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 2);

/**
 * @generated from enum guardianai.v1.familycare.WorkerStatus
 */
export enum WorkerStatus {
  /**
   * @generated from enum value: WORKER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKER_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: WORKER_STATUS_INACTIVE = 2;
   */
  INACTIVE = 2,
}

/**
 * @generated from enum guardianai.v1.familycare.WorkerStatus
 */
export type WorkerStatusJson = "WORKER_STATUS_UNSPECIFIED" | "WORKER_STATUS_ACTIVE" | "WORKER_STATUS_INACTIVE";

/**
 * Describes the enum guardianai.v1.familycare.WorkerStatus.
 */
export const WorkerStatusSchema: GenEnum<WorkerStatus, WorkerStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 3);

/**
 * @generated from enum guardianai.v1.familycare.CaregiverApplicationStatus
 */
export enum CaregiverApplicationStatus {
  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_SUBMITTED = 1;
   */
  SUBMITTED = 1,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_IN_REVIEW = 2;
   */
  IN_REVIEW = 2,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_INTERVIEW = 3;
   */
  INTERVIEW = 3,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_OFFERED = 4;
   */
  OFFERED = 4,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_INVITED = 5;
   */
  INVITED = 5,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_HIRED = 6;
   */
  HIRED = 6,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_REJECTED = 7;
   */
  REJECTED = 7,

  /**
   * @generated from enum value: CAREGIVER_APPLICATION_STATUS_WITHDRAWN = 8;
   */
  WITHDRAWN = 8,
}

/**
 * @generated from enum guardianai.v1.familycare.CaregiverApplicationStatus
 */
export type CaregiverApplicationStatusJson = "CAREGIVER_APPLICATION_STATUS_UNSPECIFIED" | "CAREGIVER_APPLICATION_STATUS_SUBMITTED" | "CAREGIVER_APPLICATION_STATUS_IN_REVIEW" | "CAREGIVER_APPLICATION_STATUS_INTERVIEW" | "CAREGIVER_APPLICATION_STATUS_OFFERED" | "CAREGIVER_APPLICATION_STATUS_INVITED" | "CAREGIVER_APPLICATION_STATUS_HIRED" | "CAREGIVER_APPLICATION_STATUS_REJECTED" | "CAREGIVER_APPLICATION_STATUS_WITHDRAWN";

/**
 * Describes the enum guardianai.v1.familycare.CaregiverApplicationStatus.
 */
export const CaregiverApplicationStatusSchema: GenEnum<CaregiverApplicationStatus, CaregiverApplicationStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 4);

/**
 * @generated from enum guardianai.v1.familycare.WorkerDocumentType
 */
export enum WorkerDocumentType {
  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_WORK_PERMIT = 1;
   */
  WORK_PERMIT = 1,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_VULNERABLE_SECTOR_CHECK = 2;
   */
  VULNERABLE_SECTOR_CHECK = 2,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_FIRST_AID_CPR = 3;
   */
  FIRST_AID_CPR = 3,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_EMPLOYMENT_AGREEMENT = 4;
   */
  EMPLOYMENT_AGREEMENT = 4,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_TD1_FEDERAL = 5;
   */
  TD1_FEDERAL = 5,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_TD1_ALBERTA = 6;
   */
  TD1_ALBERTA = 6,

  /**
   * @generated from enum value: WORKER_DOCUMENT_TYPE_DIRECT_DEPOSIT_CONFIRMATION = 7;
   */
  DIRECT_DEPOSIT_CONFIRMATION = 7,
}

/**
 * @generated from enum guardianai.v1.familycare.WorkerDocumentType
 */
export type WorkerDocumentTypeJson = "WORKER_DOCUMENT_TYPE_UNSPECIFIED" | "WORKER_DOCUMENT_TYPE_WORK_PERMIT" | "WORKER_DOCUMENT_TYPE_VULNERABLE_SECTOR_CHECK" | "WORKER_DOCUMENT_TYPE_FIRST_AID_CPR" | "WORKER_DOCUMENT_TYPE_EMPLOYMENT_AGREEMENT" | "WORKER_DOCUMENT_TYPE_TD1_FEDERAL" | "WORKER_DOCUMENT_TYPE_TD1_ALBERTA" | "WORKER_DOCUMENT_TYPE_DIRECT_DEPOSIT_CONFIRMATION";

/**
 * Describes the enum guardianai.v1.familycare.WorkerDocumentType.
 */
export const WorkerDocumentTypeSchema: GenEnum<WorkerDocumentType, WorkerDocumentTypeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 5);

/**
 * @generated from enum guardianai.v1.familycare.WorkerDocumentStatus
 */
export enum WorkerDocumentStatus {
  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_VALID = 2;
   */
  VALID = 2,

  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: WORKER_DOCUMENT_STATUS_SUPERSEDED = 5;
   */
  SUPERSEDED = 5,
}

/**
 * @generated from enum guardianai.v1.familycare.WorkerDocumentStatus
 */
export type WorkerDocumentStatusJson = "WORKER_DOCUMENT_STATUS_UNSPECIFIED" | "WORKER_DOCUMENT_STATUS_PENDING" | "WORKER_DOCUMENT_STATUS_VALID" | "WORKER_DOCUMENT_STATUS_EXPIRED" | "WORKER_DOCUMENT_STATUS_REJECTED" | "WORKER_DOCUMENT_STATUS_SUPERSEDED";

/**
 * Describes the enum guardianai.v1.familycare.WorkerDocumentStatus.
 */
export const WorkerDocumentStatusSchema: GenEnum<WorkerDocumentStatus, WorkerDocumentStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 6);

/**
 * @generated from enum guardianai.v1.familycare.TaxMode
 */
export enum TaxMode {
  /**
   * @generated from enum value: TAX_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAX_MODE_EXEMPT = 1;
   */
  EXEMPT = 1,

  /**
   * @generated from enum value: TAX_MODE_TAXABLE = 2;
   */
  TAXABLE = 2,

  /**
   * @generated from enum value: TAX_MODE_MANUAL = 3;
   */
  MANUAL = 3,
}

/**
 * @generated from enum guardianai.v1.familycare.TaxMode
 */
export type TaxModeJson = "TAX_MODE_UNSPECIFIED" | "TAX_MODE_EXEMPT" | "TAX_MODE_TAXABLE" | "TAX_MODE_MANUAL";

/**
 * Describes the enum guardianai.v1.familycare.TaxMode.
 */
export const TaxModeSchema: GenEnum<TaxMode, TaxModeJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 7);

/**
 * @generated from enum guardianai.v1.familycare.ReceiptStatus
 */
export enum ReceiptStatus {
  /**
   * @generated from enum value: RECEIPT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: RECEIPT_STATUS_CURRENT = 1;
   */
  CURRENT = 1,

  /**
   * @generated from enum value: RECEIPT_STATUS_SUPERSEDED = 2;
   */
  SUPERSEDED = 2,

  /**
   * @generated from enum value: RECEIPT_STATUS_VOID = 3;
   */
  VOID = 3,
}

/**
 * @generated from enum guardianai.v1.familycare.ReceiptStatus
 */
export type ReceiptStatusJson = "RECEIPT_STATUS_UNSPECIFIED" | "RECEIPT_STATUS_CURRENT" | "RECEIPT_STATUS_SUPERSEDED" | "RECEIPT_STATUS_VOID";

/**
 * Describes the enum guardianai.v1.familycare.ReceiptStatus.
 */
export const ReceiptStatusSchema: GenEnum<ReceiptStatus, ReceiptStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 8);

/**
 * @generated from enum guardianai.v1.familycare.IncidentStatus
 */
export enum IncidentStatus {
  /**
   * @generated from enum value: INCIDENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INCIDENT_STATUS_SUBMITTED = 1;
   */
  SUBMITTED = 1,

  /**
   * @generated from enum value: INCIDENT_STATUS_UNDER_REVIEW = 2;
   */
  UNDER_REVIEW = 2,

  /**
   * @generated from enum value: INCIDENT_STATUS_RESOLVED = 3;
   */
  RESOLVED = 3,
}

/**
 * @generated from enum guardianai.v1.familycare.IncidentStatus
 */
export type IncidentStatusJson = "INCIDENT_STATUS_UNSPECIFIED" | "INCIDENT_STATUS_SUBMITTED" | "INCIDENT_STATUS_UNDER_REVIEW" | "INCIDENT_STATUS_RESOLVED";

/**
 * Describes the enum guardianai.v1.familycare.IncidentStatus.
 */
export const IncidentStatusSchema: GenEnum<IncidentStatus, IncidentStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 9);

/**
 * @generated from enum guardianai.v1.familycare.BookingExtensionStatus
 */
export enum BookingExtensionStatus {
  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_ACCEPTED_PENDING_PAYMENT = 3;
   */
  ACCEPTED_PENDING_PAYMENT = 3,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_PAYMENT_PENDING = 4;
   */
  PAYMENT_PENDING = 4,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_CONFIRMED = 5;
   */
  CONFIRMED = 5,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_PAYMENT_FAILED = 6;
   */
  PAYMENT_FAILED = 6,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_CANCELLED = 7;
   */
  CANCELLED = 7,

  /**
   * @generated from enum value: BOOKING_EXTENSION_STATUS_REFUNDED = 8;
   */
  REFUNDED = 8,
}

/**
 * @generated from enum guardianai.v1.familycare.BookingExtensionStatus
 */
export type BookingExtensionStatusJson = "BOOKING_EXTENSION_STATUS_UNSPECIFIED" | "BOOKING_EXTENSION_STATUS_REQUESTED" | "BOOKING_EXTENSION_STATUS_DECLINED" | "BOOKING_EXTENSION_STATUS_ACCEPTED_PENDING_PAYMENT" | "BOOKING_EXTENSION_STATUS_PAYMENT_PENDING" | "BOOKING_EXTENSION_STATUS_CONFIRMED" | "BOOKING_EXTENSION_STATUS_PAYMENT_FAILED" | "BOOKING_EXTENSION_STATUS_CANCELLED" | "BOOKING_EXTENSION_STATUS_REFUNDED";

/**
 * Describes the enum guardianai.v1.familycare.BookingExtensionStatus.
 */
export const BookingExtensionStatusSchema: GenEnum<BookingExtensionStatus, BookingExtensionStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 10);

/**
 * @generated from enum guardianai.v1.familycare.BookingMessageSenderRole
 */
export enum BookingMessageSenderRole {
  /**
   * @generated from enum value: BOOKING_MESSAGE_SENDER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_MESSAGE_SENDER_ROLE_PARENT = 1;
   */
  PARENT = 1,

  /**
   * @generated from enum value: BOOKING_MESSAGE_SENDER_ROLE_CAREGIVER = 2;
   */
  CAREGIVER = 2,

  /**
   * @generated from enum value: BOOKING_MESSAGE_SENDER_ROLE_ADMIN = 3;
   */
  ADMIN = 3,
}

/**
 * @generated from enum guardianai.v1.familycare.BookingMessageSenderRole
 */
export type BookingMessageSenderRoleJson = "BOOKING_MESSAGE_SENDER_ROLE_UNSPECIFIED" | "BOOKING_MESSAGE_SENDER_ROLE_PARENT" | "BOOKING_MESSAGE_SENDER_ROLE_CAREGIVER" | "BOOKING_MESSAGE_SENDER_ROLE_ADMIN";

/**
 * Describes the enum guardianai.v1.familycare.BookingMessageSenderRole.
 */
export const BookingMessageSenderRoleSchema: GenEnum<BookingMessageSenderRole, BookingMessageSenderRoleJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 11);

/**
 * @generated from enum guardianai.v1.familycare.KnownCaregiverRequestStatus
 */
export enum KnownCaregiverRequestStatus {
  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_UNDER_REVIEW = 2;
   */
  UNDER_REVIEW = 2,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_CAREGIVER_CONSENT_REQUESTED = 3;
   */
  CAREGIVER_CONSENT_REQUESTED = 3,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_APPROVED = 4;
   */
  APPROVED = 4,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_DECLINED = 5;
   */
  DECLINED = 5,

  /**
   * @generated from enum value: KNOWN_CAREGIVER_REQUEST_STATUS_EXPIRED = 6;
   */
  EXPIRED = 6,
}

/**
 * @generated from enum guardianai.v1.familycare.KnownCaregiverRequestStatus
 */
export type KnownCaregiverRequestStatusJson = "KNOWN_CAREGIVER_REQUEST_STATUS_UNSPECIFIED" | "KNOWN_CAREGIVER_REQUEST_STATUS_REQUESTED" | "KNOWN_CAREGIVER_REQUEST_STATUS_UNDER_REVIEW" | "KNOWN_CAREGIVER_REQUEST_STATUS_CAREGIVER_CONSENT_REQUESTED" | "KNOWN_CAREGIVER_REQUEST_STATUS_APPROVED" | "KNOWN_CAREGIVER_REQUEST_STATUS_DECLINED" | "KNOWN_CAREGIVER_REQUEST_STATUS_EXPIRED";

/**
 * Describes the enum guardianai.v1.familycare.KnownCaregiverRequestStatus.
 */
export const KnownCaregiverRequestStatusSchema: GenEnum<KnownCaregiverRequestStatus, KnownCaregiverRequestStatusJson> = /*@__PURE__*/
  enumDesc(file_guardianai_v1_familycare_family_care, 12);

/**
 * @generated from service guardianai.v1.familycare.PublicFamilyCareService
 */
export const PublicFamilyCareService: GenService<{
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.GetPublicSettings
   */
  getPublicSettings: {
    methodKind: "unary";
    input: typeof GetPublicSettingsRequestSchema;
    output: typeof GetPublicSettingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.CreateCaregiverApplication
   */
  createCaregiverApplication: {
    methodKind: "unary";
    input: typeof CreateCaregiverApplicationRequestSchema;
    output: typeof CreateCaregiverApplicationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.GetCaregiverInvite
   */
  getCaregiverInvite: {
    methodKind: "unary";
    input: typeof GetCaregiverInviteRequestSchema;
    output: typeof GetCaregiverInviteResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.CreateBooking
   */
  createBooking: {
    methodKind: "unary";
    input: typeof CreateBookingRequestSchema;
    output: typeof CreateBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.CreateBookingPaymentIntent
   */
  createBookingPaymentIntent: {
    methodKind: "unary";
    input: typeof CreateBookingPaymentIntentRequestSchema;
    output: typeof CreateBookingPaymentIntentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.GetBookingStatus
   */
  getBookingStatus: {
    methodKind: "unary";
    input: typeof GetBookingStatusRequestSchema;
    output: typeof GetBookingStatusResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.PublicFamilyCareService.DownloadReceipt
   */
  downloadReceipt: {
    methodKind: "unary";
    input: typeof PublicFamilyCareServiceDownloadReceiptRequestSchema;
    output: typeof PublicFamilyCareServiceDownloadReceiptResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_familycare_family_care, 0);

/**
 * @generated from service guardianai.v1.familycare.ParentFamilyCareService
 */
export const ParentFamilyCareService: GenService<{
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.ClaimBooking
   */
  claimBooking: {
    methodKind: "unary";
    input: typeof ClaimBookingRequestSchema;
    output: typeof ClaimBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.ListMyBookings
   */
  listMyBookings: {
    methodKind: "unary";
    input: typeof ListMyBookingsRequestSchema;
    output: typeof ListMyBookingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.GetMyBooking
   */
  getMyBooking: {
    methodKind: "unary";
    input: typeof GetMyBookingRequestSchema;
    output: typeof GetMyBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.DownloadMyReceipt
   */
  downloadMyReceipt: {
    methodKind: "unary";
    input: typeof DownloadMyReceiptRequestSchema;
    output: typeof DownloadMyReceiptResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.SubmitKnownCaregiverRequest
   */
  submitKnownCaregiverRequest: {
    methodKind: "unary";
    input: typeof SubmitKnownCaregiverRequestRequestSchema;
    output: typeof SubmitKnownCaregiverRequestResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.ListMyBookingMessages
   */
  listMyBookingMessages: {
    methodKind: "unary";
    input: typeof ListMyBookingMessagesRequestSchema;
    output: typeof ListMyBookingMessagesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.SendMyBookingMessage
   */
  sendMyBookingMessage: {
    methodKind: "unary";
    input: typeof SendMyBookingMessageRequestSchema;
    output: typeof SendMyBookingMessageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.RequestBookingExtension
   */
  requestBookingExtension: {
    methodKind: "unary";
    input: typeof RequestBookingExtensionRequestSchema;
    output: typeof RequestBookingExtensionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.ParentFamilyCareService.CreateExtensionPaymentIntent
   */
  createExtensionPaymentIntent: {
    methodKind: "unary";
    input: typeof CreateExtensionPaymentIntentRequestSchema;
    output: typeof CreateExtensionPaymentIntentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_familycare_family_care, 1);

/**
 * @generated from service guardianai.v1.familycare.WorkerFamilyCareService
 */
export const WorkerFamilyCareService: GenService<{
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.ListMyOnboardingDocuments
   */
  listMyOnboardingDocuments: {
    methodKind: "unary";
    input: typeof ListMyOnboardingDocumentsRequestSchema;
    output: typeof ListMyOnboardingDocumentsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.SubmitOnboardingDocument
   */
  submitOnboardingDocument: {
    methodKind: "unary";
    input: typeof SubmitOnboardingDocumentRequestSchema;
    output: typeof SubmitOnboardingDocumentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.AcceptCaregiverInvite
   */
  acceptCaregiverInvite: {
    methodKind: "unary";
    input: typeof AcceptCaregiverInviteRequestSchema;
    output: typeof AcceptCaregiverInviteResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.ListMyGigs
   */
  listMyGigs: {
    methodKind: "unary";
    input: typeof ListMyGigsRequestSchema;
    output: typeof ListMyGigsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.GetMyGig
   */
  getMyGig: {
    methodKind: "unary";
    input: typeof GetMyGigRequestSchema;
    output: typeof GetMyGigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.AcceptAssignment
   */
  acceptAssignment: {
    methodKind: "unary";
    input: typeof AcceptAssignmentRequestSchema;
    output: typeof AcceptAssignmentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.DeclineAssignment
   */
  declineAssignment: {
    methodKind: "unary";
    input: typeof DeclineAssignmentRequestSchema;
    output: typeof DeclineAssignmentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.CheckIn
   */
  checkIn: {
    methodKind: "unary";
    input: typeof CheckInRequestSchema;
    output: typeof CheckInResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.CheckOut
   */
  checkOut: {
    methodKind: "unary";
    input: typeof CheckOutRequestSchema;
    output: typeof CheckOutResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.SubmitCareSummary
   */
  submitCareSummary: {
    methodKind: "unary";
    input: typeof SubmitCareSummaryRequestSchema;
    output: typeof SubmitCareSummaryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.SubmitIncident
   */
  submitIncident: {
    methodKind: "unary";
    input: typeof SubmitIncidentRequestSchema;
    output: typeof SubmitIncidentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.ListMyGigMessages
   */
  listMyGigMessages: {
    methodKind: "unary";
    input: typeof ListMyGigMessagesRequestSchema;
    output: typeof ListMyGigMessagesResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.SendMyGigMessage
   */
  sendMyGigMessage: {
    methodKind: "unary";
    input: typeof SendMyGigMessageRequestSchema;
    output: typeof SendMyGigMessageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.WorkerFamilyCareService.RespondBookingExtension
   */
  respondBookingExtension: {
    methodKind: "unary";
    input: typeof RespondBookingExtensionRequestSchema;
    output: typeof RespondBookingExtensionResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_familycare_family_care, 2);

/**
 * @generated from service guardianai.v1.familycare.AdminFamilyCareService
 */
export const AdminFamilyCareService: GenService<{
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof GetDashboardRequestSchema;
    output: typeof GetDashboardResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListBookings
   */
  listBookings: {
    methodKind: "unary";
    input: typeof ListBookingsRequestSchema;
    output: typeof ListBookingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GetBooking
   */
  getBooking: {
    methodKind: "unary";
    input: typeof GetBookingRequestSchema;
    output: typeof GetBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListCaregiverApplications
   */
  listCaregiverApplications: {
    methodKind: "unary";
    input: typeof ListCaregiverApplicationsRequestSchema;
    output: typeof ListCaregiverApplicationsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GetCaregiverApplication
   */
  getCaregiverApplication: {
    methodKind: "unary";
    input: typeof GetCaregiverApplicationRequestSchema;
    output: typeof GetCaregiverApplicationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.UpdateCaregiverApplication
   */
  updateCaregiverApplication: {
    methodKind: "unary";
    input: typeof UpdateCaregiverApplicationRequestSchema;
    output: typeof UpdateCaregiverApplicationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.CreateCaregiverInvitation
   */
  createCaregiverInvitation: {
    methodKind: "unary";
    input: typeof CreateCaregiverInvitationRequestSchema;
    output: typeof CreateCaregiverInvitationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListKnownCaregiverRequests
   */
  listKnownCaregiverRequests: {
    methodKind: "unary";
    input: typeof ListKnownCaregiverRequestsRequestSchema;
    output: typeof ListKnownCaregiverRequestsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ReviewKnownCaregiverRequest
   */
  reviewKnownCaregiverRequest: {
    methodKind: "unary";
    input: typeof ReviewKnownCaregiverRequestRequestSchema;
    output: typeof ReviewKnownCaregiverRequestResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListWorkers
   */
  listWorkers: {
    methodKind: "unary";
    input: typeof ListWorkersRequestSchema;
    output: typeof ListWorkersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.UpsertWorker
   */
  upsertWorker: {
    methodKind: "unary";
    input: typeof UpsertWorkerRequestSchema;
    output: typeof UpsertWorkerResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.UpsertWorkerDocument
   */
  upsertWorkerDocument: {
    methodKind: "unary";
    input: typeof UpsertWorkerDocumentRequestSchema;
    output: typeof UpsertWorkerDocumentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ReviewWorkerDocument
   */
  reviewWorkerDocument: {
    methodKind: "unary";
    input: typeof ReviewWorkerDocumentRequestSchema;
    output: typeof ReviewWorkerDocumentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.DownloadWorkerDocument
   */
  downloadWorkerDocument: {
    methodKind: "unary";
    input: typeof DownloadWorkerDocumentRequestSchema;
    output: typeof DownloadWorkerDocumentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.AssignWorker
   */
  assignWorker: {
    methodKind: "unary";
    input: typeof AssignWorkerRequestSchema;
    output: typeof AssignWorkerResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.CancelBooking
   */
  cancelBooking: {
    methodKind: "unary";
    input: typeof CancelBookingRequestSchema;
    output: typeof CancelBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.RequestRefund
   */
  requestRefund: {
    methodKind: "unary";
    input: typeof RequestRefundRequestSchema;
    output: typeof RequestRefundResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ReviewCompletedVisit
   */
  reviewCompletedVisit: {
    methodKind: "unary";
    input: typeof ReviewCompletedVisitRequestSchema;
    output: typeof ReviewCompletedVisitResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GenerateReceipt
   */
  generateReceipt: {
    methodKind: "unary";
    input: typeof GenerateReceiptRequestSchema;
    output: typeof GenerateReceiptResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.DownloadReceipt
   */
  downloadReceipt: {
    methodKind: "unary";
    input: typeof AdminFamilyCareServiceDownloadReceiptRequestSchema;
    output: typeof AdminFamilyCareServiceDownloadReceiptResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GetSettings
   */
  getSettings: {
    methodKind: "unary";
    input: typeof GetSettingsRequestSchema;
    output: typeof GetSettingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.UpdateSettings
   */
  updateSettings: {
    methodKind: "unary";
    input: typeof UpdateSettingsRequestSchema;
    output: typeof UpdateSettingsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.GeneratePayrollExport
   */
  generatePayrollExport: {
    methodKind: "unary";
    input: typeof GeneratePayrollExportRequestSchema;
    output: typeof GeneratePayrollExportResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ReopenPayrollBooking
   */
  reopenPayrollBooking: {
    methodKind: "unary";
    input: typeof ReopenPayrollBookingRequestSchema;
    output: typeof ReopenPayrollBookingResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListAuditLogs
   */
  listAuditLogs: {
    methodKind: "unary";
    input: typeof ListAuditLogsRequestSchema;
    output: typeof ListAuditLogsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.familycare.AdminFamilyCareService.ListBookingMessages
   */
  listBookingMessages: {
    methodKind: "unary";
    input: typeof ListBookingMessagesRequestSchema;
    output: typeof ListBookingMessagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_familycare_family_care, 3);

